import React, { useEffect, useState, useRef } from 'react';
import loadable from '@loadable/component';
import axios from "axios";
import queryString from "query-string";
import { useAppContext } from "../../useAppState";
import { useMutation, useQuery } from '@apollo/react-hooks';
import './CoursePlay.scss';
import { Tooltip as TooltipAntd } from 'antd';
import { Button, Modal, Overlay, Tooltip } from "react-bootstrap";
import MoonLoader from "react-spinners/MoonLoader";
import { cmsGetPathCoursePlayGraphql } from '../../helpers/cmsGetFetchPaths';
import { mergeByProperty } from '../../helpers/commonsConfigElements';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots, faCalendarAlt, faList, faTimes, faCheckCircle, faTasks, faBook, faClose, faClock, faHome, faFileAlt, faChalkboardTeacher, faCommentAlt, faGamepad, faLock, faPencilAlt, faFlag, faSearch, faChartPie, faRobot, faHouse, faBell, faInfoCircle, faStar } from '@fortawesome/free-solid-svg-icons';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { isMobile } from 'react-device-detect';
import { gql } from "@apollo/client";
import { singleAllTypesCourse, SINGLE_STUDENT_PROGRESSION, STUDENT_COURSES_NOTES, ALL_MEETING_RESERVATION, NOTIFICATION_PER_COURSE, ALL_SONDAGES_BY_COURSE, ALL_SONDAGES_ANSWERS_BY_COURSE_AND_STUDENTS, ALL_CERTIFICATES_CONFIGURATION, ALL_CERTIFICATES, GENERATE_CERTIFICATE_PDF } from '../../helpers/globalGQL';
import { useTranslation } from "react-i18next";
import { fancyTimeFormat } from "../../helpers/commonsConfigElements";
import ChatBotIcite from '../../components/ChatBotIcite/ChatBotIcite';
import moment from "moment";
import 'moment/min/locales'
import 'moment-timezone';
import { Select, Tag } from 'antd';
import DOMPurify from 'dompurify';
import Cookies from "js-cookie";
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import CertificateDisplay from '../../components/CertificateDisplay/CertificateDisplay';
import certificateIcon from '../../images/certificate-icon.png';
import BrokerPermitNumberModal from '../../components/BrokerPermitNumberModal/BrokerPermitNumberModal';

const { Option } = Select;


const StatsPercentageBox = loadable(() => import('../../components/StatsPercentageBox/StatsPercentageBox'));
const CourseIntro = loadable(() => import('../../components/CourseIntro/CourseIntro'));
const NotesEditor = loadable(() => import('../../components/NotesEditor/NotesEditor'));
const DocumentsAndNotesManual = loadable(() => import('../../components/DocumentsAndNotesManual/DocumentsAndNotesManual'));



// CoursePlayExclusiveComponents  (containers)**********************************
const VideoPlayerCnt = loadable(() => import('./CoursePlayExclusiveComponents/VideoPlayerCnt'));
const StartSlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/StartSlideCnt'));
const EndSlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/EndSlideCnt'));
const DivisionSlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/DivisionSlideCnt'));
const DocumentSlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/DocumentSlideCnt'));
const HtmlSlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/HtmlSlideCnt'));
const ScormSlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/ScormSlideCnt'));
const ExerciceMultipleChoicesSlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/ExerciceMultipleChoicesSlideCnt'));
const ExerciceOpenQuestionSlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/ExerciceOpenQuestionSlideCnt'));
const RafaleSlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/RafaleSlideCnt'));
const CalculationSlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/CalculationSlideCnt'));
const DndImagesSlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/DndImagesSlideCnt'));
const DndMultipleSlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/DndMultipleSlideCnt'));
const DndTextSlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/DndTextSlideCnt'));
const ExamSlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/ExamSlideCnt'));
const ExamMultipleChoiceSlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/ExamMultipleChoiceSlideCnt'));
const ExerciceSlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/ExerciceSlideCnt'));
const AutoEvaluation1SlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/AutoEvaluation1SlideCnt'));
const MeetingReservation = loadable(() => import('./CoursePlayExclusiveComponents/MeetingReservation'));
const SondageSlideCnt = loadable(() => import('./CoursePlayExclusiveComponents/SondageSlideCnt'));
// CoursePlayExclusiveComponents  (containers)**********************************


const SINGLE_ALL_TYPES_COURSE = gql`
      query SingleAllTypesCourse($courseTag: String!) {
        singleAllTypesCourse(courseTag: $courseTag) {
            courseTag
            courseTitle
            courseTypes
            courseContentJson
            accessJson
        }
      }
    `;

const UPDATE_STUDENT_PROGRESSION = gql`
  mutation AddOrUpdateStudentProgression(
      $studentId: ID!, 
      $studentName: String!, 
      $courseName: String!, 
      $progressionJson: String!, 
      $requestedMeetingModule: String
  ) {
    addOrUpdateStudentProgression(
        studentId: $studentId, 
        studentName: $studentName, 
        courseName: $courseName, 
        progressionJson: $progressionJson, 
        requestedMeetingModule: $requestedMeetingModule
    )
  }
`;

const ADD_TIME_CUMULATED_TO_STUDENT_PROGRESSION = gql`
  mutation AddTimeCumulatedToStudentProgression(
      $studentId: ID!, 
      $courseName: String!, 
      $playId: Int!, 
      $secondsToAdd: Int!
  ) {
    addTimeCumulatedToStudentProgression(
        studentId: $studentId, 
        courseName: $courseName, 
        playId: $playId, 
        secondsToAdd: $secondsToAdd
    )
  }
`;

const ADD_COURSES_ACCESS_LOG = gql`
  mutation AddCoursesAccessLogs(
            $studentId: ID!, 
            $courseName: String!, 
    ) {
    addCoursesAccessLogs(
            studentId: $studentId, 
            courseName: $courseName, 
        )
  }
`;

const ADD_COURSE_TO_STUDENT = gql`
  mutation AddCourseToStudent(
            $id: ID!, 
            $coursesTypeAccess: String!, 
    ) {
    addCourseToStudent(
            id: $id, 
            coursesTypeAccess: $coursesTypeAccess, 
        )
  }
`;


const ADD_EARNED_CERTIFICATE = gql`
  mutation AddEarnedCertificate(
        $studentId: Int!
        $courseName: String
        $moduleIdRelated: Int
    ) {
    addEarnedCertificate(
        studentId: $studentId 
        courseName: $courseName 
        moduleIdRelated: $moduleIdRelated 
    )
  }
`;



const CoursePlay = (props) => {

    const { t } = useTranslation();
    const { state, actions } = useAppContext();

    moment.locale(state.lang);

    // Timezone utility function
    const momentInUserTimezone = (date) => {
        return moment(date).tz(state.userInfos.timezone);
    };


    const parsedQuery = queryString.parse(window.location.search);
    const [showModal, setShowModal] = useState(false);
    const [showAdditionalInformationModal, setShowAdditionalInformationModal] = useState(false);
    const [additionalInformationModalContent, setAdditionalInformationModalContent] = useState(null);
    const [showModalContactFiltersTeam, setShowModalContactFiltersTeam] = useState(true);
    const userAccessCourseTypes = state.userInfos.coursesTypeAccess ? JSON.parse(state.userInfos.coursesTypeAccess).coursesType : [];

    const [rawCoursesData, setRawCoursesData] = useState({});
    const [orderedCourseSlidesData, setOrderedCourseSlidesData] = useState([]);
    const [backupOrderedCourseSlidesData, setBackupOrderedCourseSlidesData] = useState([]);
    const [orderedCourseSlidesLength, setOrderedCourseSlidesLength] = useState(0);
    const [lastSlideDone, setLastSlideDone] = useState(1);
    const [filesSource, setFilesSource] = useState('');
    const [currentPlayContent, setCurrentPlayContent] = useState({ listIndex: 0 });
    const [displayMeetingSection, setDisplayMeetingSection] = useState(false);
    const [userCourseRequestedMeetings, setUserCourseRequestedMeetings] = useState(null);
    const [selectedCourseReqMeeting, setSelectedCourseReqMeeting] = useState(null);
    const [userCourseProgression, setUserCourseProgression] = useState({});
    const [playListMobileMenuClass, setPlayListMobileMenuClass] = useState('play-list-menu-mobile');
    const [playListMobileMenuBtn, setPlayListMobileMenuBtn] = useState(faList);
    const [loadingData, setLoadingData] = useState(true);
    const [videoDone, setVideoDone] = useState(false);
    const [replayVideoAvailable, setReplayVideoAvailable] = useState(false);
    const [progressPercentage, setProgressPercentage] = useState(0);
    const [introPageSkipped, setIntroPageSkipped] = useState(false);
    const [firstLoad, setFirstLoad] = useState(true);
    const [startSlideFromIntro, setStartSlideFromIntro] = useState(true);
    const [resetModule, setResetModule] = useState(false);
    const [resetPercentageResults, setResetPercentageResults] = useState(false);
    const [menuHidden, setMenuHidden] = useState(false);
    const [continuousMode, setContinuousMode] = useState(false);
    const [currentNotesModalCotent, setCurrentNotesModalCotent] = useState({});
    const [allNotesEditorContent, setAllNotesEditorContent] = useState({});
    const [editorClosed, setEditorClosed] = useState(true);
    const [displaySearchMenu, setDisplaySearchMenu] = useState(false);
    const [showMenuBtnTooltip, setShowMenuBtnTooltip] = useState(false);
    const [showChatBotTooltip, setShowChatBotTooltip] = useState(0);
    const [filterAndSetMenuItemsConditionsDone, setFilterAndSetMenuItemsConditionsDone] = useState(false);
    const targetMenuBtnTooltip = useRef(null);
    const [chatBotAvailable, setChatBotAvailable] = useState(false);
    const [displayChatBotBox, setDisplayChatBotBox] = useState(false);
    const [minimizedChatBox, setMinMaxChatBotBox] = useState(false);
    const [chatBotQuestions, setChatBotQuestions] = useState(null);
    const [chatBotEmailRecipients, setChatBotEmailRecipients] = useState([]);
    const [allMeetingReservations, setAllMeetingReservations] = useState([]);
    const [bannerFullHeight, setBannerFullHeight] = useState(false);
    const [allNotifications, setAllNotifications] = useState(null);
    const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false)
    const [notificationStatus, setNotificationStatus] = useState(null)
    const [notificationHasAlreadyOpen, setNotificationHasAlreadyOpen] = useState(false);
    const [modulesRequirementsConditions, setModulesRequirementsConditions] = useState(null);
    const [allSondages, setAllSondages] = useState([]);
    const [allSondagesBackup, setAllSondagesBackup] = useState([]);
    const [allSondagesAnswers, setAllSondagesAnswers] = useState([]);
    const [currentRunningSondage, setCurrentRunningSondage] = useState(null);
    const [currentRunningSondageAnswers, setCurrentRunningSondageAnswers] = useState([]);
    const [teamsFiltersModalTexts, setTeamsFiltersModalTexts] = useState({});
    const [teamsFiltersEnabled, setTeamsFiltersEnabled] = useState(false);
    const [teamsFilters, setTeamsFilters] = useState([]);
    const [contactTeamSelected, setContactTeamSelected] = useState(null);
    const [showModalCertificateDisplay, setShowModalCertificateDisplay] = useState(false);
    const [currentCertificateData, setCurrentCertificateData] = useState(null);
    const [allCertificates, setAllCertificates] = useState(null);
    const [allCertificatesConfigurations, setAllCertificatesConfigurations] = useState(null);
    const [courseAccessJson, setCourseAccessJson] = useState([]);


    // *****************************************************************
    // Custonm  - Rencontres Intact - Ambassadeurs Contact AP
    // *****************************************************************

    const isParcoursRencontreAmbassadeurs = parsedQuery.tag === 'RencontreIntactambassadeursContactAP';

    useQuery(STUDENT_COURSES_NOTES,
        {
            skip: Object.keys(state.userInfos).length <= 0,
            variables: {
                studentId: parseInt(state.userInfos.id),
                courseName: parsedQuery.tag
            },
            onCompleted(res) {
                if (res) {
                    if (res.singleCoursesStudentNotes) {
                        setAllNotesEditorContent(JSON.parse(res.singleCoursesStudentNotes.notesEditorJson));
                    }
                }
            }
        })

    useQuery(SINGLE_ALL_TYPES_COURSE,
        {
            skip: Object.keys(state.userInfos).length <= 0,
            variables: {
                courseTag: parsedQuery.tag
            },
            onCompleted(res) {
                console.log('SINGLE_ALL_TYPES_COURSE');
                console.log(res);
                if (res.singleAllTypesCourse.accessJson) {
                    setCourseAccessJson(res.singleAllTypesCourse.accessJson ? JSON.parse(res.singleAllTypesCourse.accessJson) : []);
                }
            }
        })

    //Fetch all notifications (Wait until we get cohort of the user)
    const { refetch: refetchAllNotification } = useQuery(NOTIFICATION_PER_COURSE,
        {
            notifyOnNetworkStatusChange: true,
            skip: !state.userInfos.cohortes,
            variables: {
                course: parsedQuery.tag,
            },
            onCompleted(res) {

                const allNotificationsWithStatus = res.notificationPerCourse
                const allNotificationsFilterCohorts = []


                allNotificationsWithStatus.forEach((notification) => {
                    //Filter if cohort field isn't empty

                    if (
                        notification.courses &&
                        JSON.parse(notification.courses)[parsedQuery.tag]
                    ) {
                        if (notification.cohorts !== null) {
                            JSON.parse(notification.cohorts).forEach((cohorte) => {
                                if (state && state.userInfos.cohortes.length > 0) {
                                    state.userInfos.cohortes.forEach((cohorteStudent) => {
                                        if (cohorte === cohorteStudent.cohorteId && !allNotificationsFilterCohorts.includes(notification)) {
                                            allNotificationsFilterCohorts.push(notification);
                                        }
                                    })
                                }
                            })
                        } else {
                            allNotificationsFilterCohorts.push(notification);
                        }
                    }
                })
                setAllNotifications(allNotificationsFilterCohorts);
            }
        }
    );

    const { loading: sondagesByCourseLoading } = useQuery(ALL_SONDAGES_BY_COURSE,
        {
            variables: {
                courseName: parsedQuery.tag
            },
            fetchPolicy: 'no-cache',
            errorPolicy: 'ignore',
            notifyOnNetworkStatusChange: true,
            onError(err) {
                console.log(err)
            },
            onCompleted(res) {

                let resData = res.allSondagesByCourse;

                if (resData) {
                    console.log('ALL_SONDAGES_BY_COURSE', resData);

                    setAllSondages([...resData]);
                    setAllSondagesBackup([...resData]);
                }


            }
        })

    const { loading: allSondageAnswersbyCourseAndStudentLoading, refetch: refetchSondagesAnswers } = useQuery(ALL_SONDAGES_ANSWERS_BY_COURSE_AND_STUDENTS,
        {
            variables: {
                studentId: parseInt(state.userInfos.id),
                courseName: parsedQuery.tag
            },
            fetchPolicy: 'no-cache',
            errorPolicy: 'ignore',
            notifyOnNetworkStatusChange: true,
            onError(err) {
                console.log(err)
            },
            onCompleted(res) {

                let resData = res.allSondageAnswersbyCourseAndStudent;

                console.log('ALL_SONDAGES_ANSWERS_BY_COURSE_AND_STUDENTS', resData);

                if (resData) {
                    setAllSondagesAnswers(resData)
                }


            }
        })

    //Show notifications modal
    const showModalNotification = () => {
        setIsNotificationModalOpen(true);
        setNotificationHasAlreadyOpen(true);
    };

    //Close notifications modal
    const handleOkModalNotification = () => {
        setIsNotificationModalOpen(false);
        setNotificationHasAlreadyOpen(true);
    };

    //Here I get data to know if I need to show score or not
    const { loading: loadingProgression } = useQuery(SINGLE_STUDENT_PROGRESSION,
        {
            skip: Object.keys(state.userInfos).length <= 0,
            variables: {
                studentId: parseInt(state.userInfos.id),
                courseName: parsedQuery.tag
            },
            onCompleted(res) {
                if (res) {
                    let responseProgression = res.singleStudentsProgression
                    let savedProgression = [];

                    /***************SEND ACCESSLOG INPUT*******************/
                    if (Object.keys(state.userInfos).length > 0) {
                        addCoursesAccessLog({
                            variables: {
                                studentId: state.userInfos.id,
                                courseName: parsedQuery.tag
                            }
                        })
                    }

                    /***************GET COURSE CONTENT FROM CMS AND SET ALL NECESSARY CONFIGS TO START COURSEPLAY*******************/
                    axios.post(state.cms2_baseURL + '/graphql', cmsGetPathCoursePlayGraphql(parsedQuery.tag), {

                        headers: {
                            authorization: `Bearer ${process.env.REACT_APP_CMS_API_TOKEN}`
                        }
                    }).then(result => {
                        const courseData = result.data.data.model_courses[0];

                        // Redirect if course is draft
                        if (courseData.status === 'draft') {
                            window.location.href = process.env.REACT_APP_ENV === 'production' ? '/liste-formations' : '/dev/liste-formations';
                        }

                        console.log('enable_modules_requirements', courseData.enable_modules_requirements);
                        console.log('modules_requirements_conditions', courseData.modules_requirements_conditions);



                        if (courseData.enable_modules_requirements && courseData.modules_requirements_conditions && courseData.modules_requirements_conditions.length > 0) {
                            setModulesRequirementsConditions(courseData.modules_requirements_conditions.map(conditionItem => {
                                return {
                                    module_blocked: conditionItem.module_blocked,
                                    modules_required: conditionItem.modules_required.split(',')
                                }
                            }))
                        }

                        const courseTypes = courseData['course_types'] ? courseData['course_types'].map(cType => cType['course_types_id']['course_type']) : []

                        let isCourseContinuous = false;

                        // ***************************************************************************************
                        // Conditions (isCourseContinuous) for cohortes
                        // ***************************************************************************************
                        if (state.userInfos.cohortesJson) {
                            const cohorteCourse = state.userInfos.cohortesJson.find(elCohort => courseTypes.includes(elCohort.course) || courseData['course_tag'] === elCohort.course);
                            let thisCourseCohorte = cohorteCourse ? state.userInfos.cohortes.filter(cohorte => cohorte.cohorteId === cohorteCourse.cohorteID) : []


                            if (thisCourseCohorte.length > 0) {
                                thisCourseCohorte = thisCourseCohorte[0]
                                if (thisCourseCohorte.continuousModeCourses) {
                                    JSON.parse(thisCourseCohorte.continuousModeCourses).map(cType => {
                                        if (courseTypes.includes(cType.tag) || cType.tag === parsedQuery.tag) {
                                            isCourseContinuous = true

                                            console.log(cType);
                                        }
                                    })
                                }
                            }
                        }
                        // ***************************************************************************************
                        // Conditions (isCourseContinuous) for cohortes
                        // ***************************************************************************************



                        // ***************************************************************************************
                        // Conditions (isCourseContinuous) for general
                        // ***************************************************************************************
                        if (
                            (courseData.reading_mode_internal === 'continuous' && state.userInfos.isInternal) ||
                            (courseData.reading_mode_external === 'continuous' && !state.userInfos.isInternal)
                        ) {
                            isCourseContinuous = true
                        }

                        // ***************************************************************************************
                        // Conditions (isCourseContinuous) for general
                        // ***************************************************************************************


                        let modulesToLoopCondition = [
                            { type: 'video', typeIdFieldName: 'video_type_id', menuIcon: faYoutube },
                            { type: 'exercice', typeIdFieldName: 'exercice_type_id', menuIcon: faTasks },
                            { type: 'exam', typeIdFieldName: 'exam_type_id', menuIcon: faTasks },
                            { type: 'exammultiplechoice', typeIdFieldName: 'exam_multiple_choice_type_id', menuIcon: faTasks },
                            { type: 'scorm', typeIdFieldName: 'scorm_type_id', menuIcon: faChalkboardTeacher },
                            { type: 'dndtext', typeIdFieldName: 'drag_and_drop_text_type_id', menuIcon: faGamepad },
                            { type: 'dndmultiple', typeIdFieldName: 'drag_and_drop_text_multiple_targets_type_id', menuIcon: faGamepad },
                            { type: 'dndimages', typeIdFieldName: 'drag_and_drop_images_type_id', menuIcon: faGamepad },
                            { type: 'calculation', typeIdFieldName: 'calculation_type_id', menuIcon: faGamepad },
                            { type: 'rafale', typeIdFieldName: 'rafale_type_id', menuIcon: faGamepad },
                            { type: 'documents', typeIdFieldName: 'documents_type_id', menuIcon: faFileAlt },
                            { type: 'html', typeIdFieldName: 'html_type_id', menuIcon: faCommentAlt },
                            { type: 'exerciceopenquestion', typeIdFieldName: 'exercice_open_question_type_id', menuIcon: faTasks },
                            { type: 'exercicemultiplechoices', typeIdFieldName: 'exercice_multiple_choices_type_id', menuIcon: faTasks },
                            { type: 'start', typeIdFieldName: 'start_type_id', menuIcon: faHome },
                            { type: 'end', typeIdFieldName: 'end_type_id', menuIcon: faFlag },
                            { type: 'division', typeIdFieldName: 'division_type_id', menuIcon: faChartPie },
                            { type: 'autoevaluation1', typeIdFieldName: 'auto_evaluation_1_type_id', menuIcon: faChartPie },
                        ]

                        // let orderedData = courseData['courses_modules'].sort((a, b) => a.sort - b.sort).map((item, index) => {
                        //     let playType = item['modules_id']['type']
                        //     let playContent = {}

                        //     modulesToLoopCondition.map(moduleItem => {
                        //         if (item['modules_id']['type'] === moduleItem.type) {
                        //             playContent = item['modules_id']['module_' + moduleItem.type + '_content'][0][moduleItem.typeIdFieldName]
                        //             playContent['menuIcon'] = moduleItem.menuIcon;
                        //         }
                        //     })

                        //     return ({ ...playContent, playType: playType, listIndex: index, course_tag: parsedQuery.tag })
                        // });

                        // Pre-calculate this to avoid repetitive string operations within the loop
                        const moduleMap = {};
                        modulesToLoopCondition.forEach(moduleItem => {
                            moduleMap[moduleItem.type] = {
                                typeIdFieldName: moduleItem.typeIdFieldName,
                                menuIcon: moduleItem.menuIcon
                            };
                        });

                        // Main transformation
                        let orderedData = courseData.courses_modules
                            .sort((a, b) => a.sort - b.sort)
                            .map((item, index) => {
                                let moduleType = item.modules_id.type;
                                let playContent = {};

                                if (moduleMap[moduleType]) {
                                    playContent = item.modules_id['module_' + moduleType + '_content'][0][moduleMap[moduleType].typeIdFieldName];
                                    playContent.menuIcon = moduleMap[moduleType].menuIcon;
                                }


                                return {
                                    ...playContent,
                                    playType: moduleType,
                                    listIndex: index,
                                    course_tag: parsedQuery.tag,
                                    moduleContainerId: item.modules_id.id,
                                    ...(item.modules_id.display_additional_information ? { additionalInformation: item.modules_id.additional_information } : {}),
                                };
                            });





                        // ******************************************************************
                        // SET BACKUP ORDERED COURSES LIST DATA BEFORE ANY REORDERING/FILTERING
                        setBackupOrderedCourseSlidesData(orderedData);

                        /***************SET PROGRESSION IF EXIST + ADD LISTINDEX TO REQUESTED MEETINGS ITEMS*******************/
                        if (responseProgression) {
                            if (responseProgression.progressionJson) {
                                savedProgression = JSON.parse(responseProgression.progressionJson)
                            }

                            addLisIndexToRequestedMeeting(responseProgression.requestedMeetings, orderedData)
                        }


                        let progressionLayout = orderedData.map((item, i) => ({
                            playId: typeof item.id === 'string' ? parseInt(item.id) : item.id,
                            playType: item.playType,
                            listIndex: item.listIndex,
                            done: false,
                            moduleContainerId: item.moduleContainerId
                        }));
                        let orderDataLength = orderedData.filter(item => item.playType !== "division").length;

                        if (orderedData.length <= 0) {
                            props.history.push('/liste-formations');
                        }

                        // ******************************************************************
                        // CUSTOM CONDITION TO DISPLAY WEBZONE MODULE IN CONTACT
                        if (!state.userInfos.webzone && ['goBRIOestmonoutildetravailprincipalexterne'].includes(parsedQuery.tag)) {
                            orderDataLength = orderDataLength - 1
                        }
                        // CUSTOM CONDITION TO DISPLAY WEBZONE MODULE IN CONTACT
                        // ******************************************************************




                        /*****************************************
                       DÉFINIR LES FILTRES [START]
                       *****************************************/
                        if (courseData.enable_filters === true) {
                            console.log('DÉFINIR LES FILTRES [START]')

                            // Create courseTag
                            setTeamsFiltersEnabled(true);

                            // Create teamsFiltersModalText
                            const teamsFiltersModalText = {
                                capitalised: courseData[`filter_type_name_${state.lang}`] + " ",
                                lowerCase: courseData[`filter_type_name_${state.lang}`].toLowerCase() + " "
                            };
                            setTeamsFiltersModalTexts(teamsFiltersModalText);

                            // Create teamsFilters
                            const teamsFilters = courseData.filters.map(filter => ({
                                teamLabel: filter[`filter_title_${state.lang}`],
                                modules: filter.filtered_modules
                            }));
                            setTeamsFilters(teamsFilters);


                            // Define selected teams
                            const storageCourseTeamSelected = localStorage.getItem('courseTeamSelected');

                            console.log('storageCourseTeamSelected', storageCourseTeamSelected)

                            const teamLabels = teamsFilters.map(filter => filter.teamLabel);

                            if (storageCourseTeamSelected !== null && teamLabels.includes(storageCourseTeamSelected)) {
                                setContactTeamSelected(storageCourseTeamSelected);
                                if (storageCourseTeamSelected) {
                                    let thisTeamModules = teamsFilters.find(element => element.teamLabel === storageCourseTeamSelected).modules;



                                    let oldModules = [...orderedData]

                                    let filteredModules = oldModules.filter(module => thisTeamModules.includes(module.moduleContainerId))

                                    filteredModules.forEach((module, index) => {
                                        module.listIndex = index
                                    })

                                    orderDataLength = filteredModules.filter(item => item.playType !== "division").length;



                                    console.log('filteredModules', filteredModules);

                                    // Écrire la liste des modules ID
                                    let moduleContainerIDs = filteredModules.map(module => module.moduleContainerId);
                                    console.log("Liste des modules ID >>>>>> :", moduleContainerIDs.join(', '));

                                    orderedData = filteredModules

                                    localStorage.setItem('courseTeamSelected', storageCourseTeamSelected);
                                } else {
                                    localStorage.removeItem('courseTeamSelected');
                                }
                            }
                            console.log('DÉFINIR LES FILTRES [END]')
                        }
                        /*****************************************
                         DÉFINIR LES FILTRES [END]
                        *****************************************/

                        setRawCoursesData(courseData);
                        setFilesSource(courseData.files_source);
                        setOrderedCourseSlidesData(orderedData);
                        setOrderedCourseSlidesLength(orderDataLength);
                        setContinuousMode(isCourseContinuous);
                        setChatBotAvailable(courseData.chatBotActivated);
                        setChatBotQuestions(courseData.chatBotQuestions);
                        setChatBotEmailRecipients(courseData.chatBotEmailRecipients);
                        setBannerFullHeight(courseData.banner_full_height);


                        /***************SET OR RETRIEVE PROGRESSION LAYOUT*******************/
                        if (savedProgression.length === 0) {
                            setUserCourseProgression({
                                [parsedQuery.tag]: progressionLayout
                            });
                        } else {

                            let target = progressionLayout;
                            let source = savedProgression.filter(sourceItem => target.find(targetItem => targetItem.playId.toString() === sourceItem.playId.toString() && targetItem.playType === sourceItem.playType));

                            mergeByProperty(target, source, ['playId', 'playType']);

                            target = target.map((old, i) => ({ ...old, listIndex: i }));

                            setUserCourseProgression({
                                [parsedQuery.tag]: target
                            });

                            let prevSlideTarget, index = target.length - 1;
                            for (; index >= 0; index--) {
                                if (target[index].done) {
                                    prevSlideTarget = target[index];
                                    setLastSlideDone(prevSlideTarget['listIndex'])
                                    break;
                                }
                            }

                            setProgressPercentage(Math.ceil(target.filter(item => item.done === true && item.playType !== 'division').length * 100 / orderDataLength));
                        }






                        /***************ASSIGN COURSE TO STUDENT PROFILE IF COMING FROM DEEP URL*******************/
                        const coursesTypeAccess = state.userInfos.coursesTypeAccess ? JSON.parse(state.userInfos.coursesTypeAccess) : { coursesType: [] }
                        let userWithCourseCTypesCompare = coursesTypeAccess.coursesType.filter(cType => courseTypes.includes(cType) || cType === parsedQuery.tag)

                        // Global Access by (Affiliation, Profile or Title) and userAccessCourseTypes ************
                        let accessByGlobalConfig = false;
                        if (!userAccessCourseTypes.includes('Tout')) {

                            if (courseAccessJson) {
                                courseAccessJson.forEach(accessElement => {
                                    let conditionLength = 0;
                                    let conditionChecked = 0;

                                    Object.keys(accessElement).forEach(accessKey => {

                                        if (accessElement[accessKey] && accessElement[accessKey].length > 0) {
                                            conditionLength++
                                        }

                                        if (accessElement[accessKey].includes(state.userInfos[accessKey])) {
                                            conditionChecked++
                                        }

                                        if (accessKey === 'webzone' && state.userInfos[accessKey]) {
                                            conditionChecked++
                                        }
                                    })

                                    if (conditionChecked === conditionLength) {
                                        accessByGlobalConfig = true
                                    }
                                })
                            }

                            console.log('courseAccessJson');
                            console.log(courseAccessJson);
                            console.log('accessByGlobalConfig', accessByGlobalConfig)

                        }

                        if (userWithCourseCTypesCompare.length === 0) {
                            if (
                                (state.userInfos.isInternal && courseData.deeplink_access_internal) ||
                                (!state.userInfos.isInternal && courseData.deeplink_access_external) ||
                                userAccessCourseTypes.includes('Tout') ||
                                accessByGlobalConfig
                            ) {
                                addCourseToStudent({
                                    variables: {
                                        id: state.userInfos.id,
                                        coursesTypeAccess: JSON.stringify({
                                            coursesType: [
                                                ...coursesTypeAccess.coursesType,
                                                parsedQuery.tag
                                            ]
                                        })
                                    }
                                })
                            } else {
                                props.history.push('/liste-formations');
                            }

                        }

                        setLoadingData(false)


                    }).catch(err => {
                        console.log('Error fetching results ', err);
                        // throw new Error(err);
                    });
                }
            }
        });


    const { loading: loadingMeetings } = useQuery(ALL_MEETING_RESERVATION,
        {

            skip: !parsedQuery.tag,
            variables: {
                courseName: parsedQuery.tag,
                fromLms: true
            },
            onCompleted(res) {
                console.log('ALL_MEETING_RESERVATION')
                console.log(res)
                if (res.allMeetingReservation) {
                    console.log(res.allMeetingReservation);
                    setAllMeetingReservations(res.allMeetingReservation)
                }
            },
            onError(error) {
                console.log(error)
            }
        });


    const { loading: loadingAllCertificatesConfiguration, refetch: refetchAllCertificatesConfiguration } = useQuery(ALL_CERTIFICATES_CONFIGURATION,
        {
            fetchPolicy: 'no-cache',
            errorPolicy: 'ignore',
            notifyOnNetworkStatusChange: true,
            skip: !parsedQuery.tag,
            variables: {
                filters: JSON.stringify({
                    courseName: parsedQuery.tag,
                    status: 'published'
                }),
            },
            onCompleted(res) {
                console.log('ALL_CERTIFICATES_CONFIGURATION')
                console.log(res)
                if (res.allCertificatesConfigurations) {
                    console.log(res.allCertificatesConfigurations);

                    const configurations = res.allCertificatesConfigurations;

                    setAllCertificatesConfigurations(configurations)
                }
            },
            onError(error) {
                console.log(error)
            }
        });
    const { loading: loadingAllCertificates, refetch: refetchAllCertificates } = useQuery(ALL_CERTIFICATES,
        {
            fetchPolicy: 'no-cache',
            errorPolicy: 'ignore',
            notifyOnNetworkStatusChange: true,
            skip: !parsedQuery.tag,
            variables: {
                filters: JSON.stringify({
                    studentId: typeof state.userInfos.id === 'string' ? parseInt(state.userInfos.id) : state.userInfos.id,
                    courseName: parsedQuery.tag,
                    status: 'published'
                }),
            },
            onCompleted(res) {
                console.log('ALL_CERTIFICATES')
                console.log(res)
                if (res && res.allCertificates && res.allCertificates.rows) {
                    const certificates = res.allCertificates.rows
                        .filter(cert => cert.certificates_configurations && cert.certificates_configurations.status === 'published')
                        .sort((a, b) => new Date(b.dateEarned) - new Date(a.dateEarned));
                    setAllCertificates(certificates)
                }
            },
            onError(error) {
                console.log(error)
            }
        });


    const [updateProgression, { loading: updateProgressionLoading }] = useMutation(
        UPDATE_STUDENT_PROGRESSION,
        {
            onCompleted(response) {
                if (response.addOrUpdateStudentProgression) {

                    console.log('updateProgression - onCompleted -----------------------------');

                    let progressionItemReqMeetings = response.addOrUpdateStudentProgression
                    console.log(progressionItemReqMeetings)
                    console.log(backupOrderedCourseSlidesData)
                    addLisIndexToRequestedMeeting(progressionItemReqMeetings, backupOrderedCourseSlidesData)

                    filterAndSetMenuItemsConditions();
                }
            },
            onError(res) {
                console.log(res);
                console.log(res.response);
                console.log(res.graphQLErrors);
                console.log(res.operation);
            }
        }
    );

    const [addTimeCumulatedToStudentProgression] = useMutation(
        ADD_TIME_CUMULATED_TO_STUDENT_PROGRESSION,
        {
            onCompleted(response) {
                if (response.addTimeCumulatedToStudentProgression) {
                    //console.log(progressionItem)
                }
            },
            onError({ response, operation, graphQLErrors }) {
                console.log(response);
                console.log(graphQLErrors);
            }
        }
    );

    const [addCoursesAccessLog] = useMutation(
        ADD_COURSES_ACCESS_LOG,
        {
            onCompleted(response) {
                //console.log(response.addCoursesAccessLogs);
            },
            onError({ response, operation, graphQLErrors }) {
                console.log(response);
                console.log(graphQLErrors);
            }
        }
    );


    const [addCourseToStudent] = useMutation(
        ADD_COURSE_TO_STUDENT,
        {
            onCompleted(response) {
                window.location.reload(false);
            },
            onError({ response, operation, graphQLErrors }) {
                console.log(response);
                console.log(graphQLErrors);
            }
        }
    );


    const [addEarnedCertificate] = useMutation(
        ADD_EARNED_CERTIFICATE,
        {
            onCompleted(response) {
                if (response && response.addEarnedCertificate) {
                    console.log('ADD_EARNED_CERTIFICATE response');
                    const parsedResponse = JSON.parse(response.addEarnedCertificate);



                    if (
                        parsedResponse.configurationStatus === 'published'
                    ) {
                        setCurrentCertificateData(parsedResponse);
                        setShowModalCertificateDisplay(true);
                        refetchAllCertificates();
                    }

                }
            },
            onError({ response, operation, graphQLErrors }) {
                console.log(response);
                console.log(graphQLErrors);
            }
        }
    );

    const [generateCetificatePdf] = useMutation(
        GENERATE_CERTIFICATE_PDF,
        {
            onCompleted(response) {
                if (response && response.generateCetificatePdf) {
                    console.log('GENERATE_CERTIFICATE_PDF response');
                    const parsedResponse = JSON.parse(response.generateCetificatePdf);

                    setCurrentCertificateData(parsedResponse);
                    setShowModalCertificateDisplay(true);
                }
            },
            onError({ response, operation, graphQLErrors }) {
                console.log(response);
                console.log(graphQLErrors);
            }
        }
    );

    //HANDLE BACK PAGE EVENT******************************
    useEffect(() => {
        scrollSlideMenuOnChange();

        if (introPageSkipped === true) {
            window.onpopstate = (event) => {
                event.stopImmediatePropagation();
                handleReturnToIntro();

                window.onpopstate = () => { }
            };
        }

        actions.setPageName(introPageSkipped ? 'formation' : 'formation-intro');

        //What's the most important status in all notifications
        if (allNotifications && allNotifications.length > 0) {
            const status = [];

            allNotifications.forEach((item) => {
                status.push(item.importance)
            })

            if (status.includes('Urgent') && !notificationHasAlreadyOpen) {
                setNotificationStatus('Urgent');
                showModalNotification();
            } else {
                setNotificationStatus('Standard')
            }
        }

        setTimeout(() => {
            setShowChatBotTooltip(prev => { return prev + 1 })
            setTimeout(() => {
                setShowChatBotTooltip(prev => { return prev + 1 })
            }, 5000)
        }, 2000)
        Cookies.set('currentCourseTag', parsedQuery.tag, { expires: 360 });

    }, [introPageSkipped, allNotifications,])
    //HANDLE BACK PAGE EVENT******************************



    useEffect(() => {


        //TEMPORARY FIX FOR MISORDERING BUG 
        if (parsedQuery.tag === "goBRIOestmonoutildetravailprincipalexterne" && parsedQuery.meeting) {

            var safeUrl1 = DOMPurify.sanitize((process.env.REACT_APP_ENV === 'production' ? '' : '/dev') + "/formation/?tag=" + parsedQuery.tag + '&skipIntro=' + true + '&playId=337&playType=division&meeting=true', { ALLOWED_URI_REGEXP: /^(https?|ftp):/ });
            var safeUrl2 = DOMPurify.sanitize((process.env.REACT_APP_ENV === 'production' ? '' : '/dev') + "/formation/?tag=" + parsedQuery.tag + '&skipIntro=' + true + '&playId=339&playType=division&meeting=true', { ALLOWED_URI_REGEXP: /^(https?|ftp):/ });

            if (parseInt(parsedQuery.playId) === 79) {
                window.location.href = safeUrl1;
            }

            if (parseInt(parsedQuery.playId) === 639) {
                window.location.href = safeUrl2;
            }
        }
        //TEMPORARY FIX FOR MISORDERING BUG 

        let thisUserCourseProgression = userCourseProgression[rawCoursesData.course_tag];

        if (parsedQuery.skipIntro === 'true') {
            setIntroPageSkipped(true)
        }

        if (currentPlayContent && !parsedQuery.sondageId) {
            if (currentPlayContent.id) {
                if (introPageSkipped) {
                    window.history.pushState("", "", (process.env.REACT_APP_ENV === 'production' ? '' : '/dev') + "/formation/?tag=" + parsedQuery.tag + '&skipIntro=' + introPageSkipped + '&playId=' + currentPlayContent.id + '&playType=' + currentPlayContent.playType);
                } else {
                    window.history.pushState("", "", (process.env.REACT_APP_ENV === 'production' ? '' : '/dev') + "/formation/?tag=" + parsedQuery.tag + '&skipIntro=' + introPageSkipped);
                }
            }
        }

        if (thisUserCourseProgression) {

            console.log(orderedCourseSlidesData)
            let filteredProgress = thisUserCourseProgression.filter(item => orderedCourseSlidesData.find(item2 => (item2.id.toString() === item.playId.toString()) && item2.playType === item.playType && item2.playType !== 'division'))

            setProgressPercentage(Math.ceil(filteredProgress.filter(item => item.done === true).length * 100 / orderedCourseSlidesLength))

            filterAndSetMenuItemsConditions();

            /***************HANLDE GO TO SELECTED SLIDE FROM URL OR GO TO FIRST SLIDE NOT DONE*******************/
            console.log('HANLDE GO TO SELECTED SLIDE FROM URL OR GO TO FIRST SLIDE NOT DONE');
            console.log(firstLoad);
            console.log(filterAndSetMenuItemsConditionsDone);

            if (firstLoad && filterAndSetMenuItemsConditionsDone) {
                let i = 0;
                let notDoneFound = false;

                if (!parsedQuery.playId && !parsedQuery.sondageId) {

                    const allModuleCntId = orderedCourseSlidesData.map(item => item.moduleContainerId);

                    const isProgressionNotDone = (progression) => !progression.done && allModuleCntId.includes(progression.moduleContainerId);

                    const isBlockedMeeting = (index) => {
                        return userCourseRequestedMeetings?.some(el => el.blocked && el.listIndex === index);
                    };

                    while (i < thisUserCourseProgression.length && !notDoneFound) {
                        const progression = thisUserCourseProgression[i];
                        const stopWhile = isProgressionNotDone(progression) || isBlockedMeeting(i);

                        if (stopWhile) {
                            const selectedSlide = orderedCourseSlidesData.find(item =>
                                progression.playId.toString() === item.id.toString() && progression.playType === item.playType
                            );

                            if (selectedSlide) {
                                const sondage = allSondages.find(sondage => sondage.prevModuleRelated === null);
                                handleCurrentPlayChange({
                                    listIndex: selectedSlide.listIndex,
                                    sondage: selectedSlide.listIndex === 0 && sondage ? sondage : null
                                });
                            }

                            notDoneFound = true;
                            setFirstLoad(false);
                        }
                        i++;
                    }
                } else {
                    const selectedSlide = orderedCourseSlidesData.find(item => parsedQuery.playId && parsedQuery.playId.toString() === item.id.toString() && parsedQuery.playType === item.playType);

                    if (selectedSlide) {
                        const progressionIsExistant = Object.values(thisUserCourseProgression).some(item => item.startDate);

                        handleCurrentPlayChange({
                            ...(parsedQuery.meeting ? {
                                listIndex: progressionIsExistant ? selectedSlide.listIndex : selectedSlide.listIndex - 1,
                                forceDisplayMeetingPage: progressionIsExistant
                            } : {
                                listIndex: selectedSlide.listIndex
                            }),
                        });
                    } else if (parsedQuery.sondageId) {
                        const sondage = allSondages.find(sondage => sondage.id === parsedQuery.sondageId);

                        if (sondage) {
                            handleCurrentPlayChange({ sondage });
                        } else {
                            redirectToFormation();
                        }
                    } else {
                        redirectToFormation();
                    }

                    function redirectToFormation() {
                        var safeUrl = DOMPurify.sanitize((process.env.REACT_APP_ENV === 'production' ? '' : '/dev') + "/formation/?tag=" + parsedQuery.tag + '&skipIntro=' + false, { ALLOWED_URI_REGEXP: /^(https?|ftp):/ });

                        window.location.href = safeUrl;
                    }

                    setFirstLoad(false)
                }
            }
        }


        /***************RESET MODULE STATE FOR REFRESH PURPOSES*******************/
        //console.log(resetModule);
        if (resetModule) {
            setTimeout(() => {
                setResetModule(false)
            }, 600)
        }

    }, [...(currentPlayContent ? [currentPlayContent.listIndex, currentPlayContent.id] : []), userCourseProgression, loadingProgression, userCourseRequestedMeetings, filterAndSetMenuItemsConditionsDone, resetModule, allSondages, firstLoad])


    useEffect(() => {

        /***************SET PREGRESSION AS DONE FOR THESE PARTICULAR MODULE WHEN ACCESS*******************/
        if (currentPlayContent.id && introPageSkipped && currentRunningSondage === null) {
            if (['start', 'end', 'division', 'documents', 'html'].includes(currentPlayContent.playType) && !currentPlayContent.completionOnNextButtonClick) {
                updateCurrentUserProgression(true, false, true, true);
            } else {
                updateCurrentUserProgression(false, false, false, false);
            }

            // 30 seconds timer to add time cumulated in progression ***********************
            let timeCumulate = 0;
            let timeCumulateIntevalSeconds = 60;

            const timerInterval = setInterval(() => {
                timeCumulate += 1

                if (timeCumulate > 60 && timeCumulate % timeCumulateIntevalSeconds === 0) {
                    addTimeCumulatedToStudentProgression({
                        variables: {
                            studentId: state.userInfos.id,
                            courseName: rawCoursesData['course_tag'],
                            playId: typeof currentPlayContent.id === 'string' ? parseInt(currentPlayContent.id) : currentPlayContent.id,
                            secondsToAdd: timeCumulateIntevalSeconds,
                        }
                    })
                }
            }, 1000);
            return () => clearInterval(timerInterval);
        }


    }, [...(currentPlayContent ? [currentPlayContent.listIndex, currentPlayContent.id, introPageSkipped] : []), contactTeamSelected, teamsFiltersEnabled])




    const addLisIndexToRequestedMeeting = (requestedMeetings, orderedSlidesData) => {
        if (requestedMeetings) {
            console.log(requestedMeetings)
            let reqMeetings = JSON.parse(requestedMeetings);

            reqMeetings.map(meeting => {

                let moduleListIndex = orderedSlidesData.find(el => el.id.toString() === meeting.courseModuleBlocked.toString() && el.playType === meeting.courseModuleBlockedType)

                if (moduleListIndex) {
                    meeting.listIndex = moduleListIndex.listIndex
                }
            })

            reqMeetings.sort((a, b) => a.listIndex - b.listIndex);

            console.log('addLisIndexToRequestedMeeting -------');
            console.log(reqMeetings);

            setUserCourseRequestedMeetings(reqMeetings)
        }
    }

    const filterAndSetMenuItemsConditions = () => {
        setOrderedCourseSlidesData(prev => {

            prev.map((el, i) => {

                let thisUserProgression = userCourseProgression[rawCoursesData.course_tag];
                let thisSlideStartDate = null;
                let thisSlideDone = false;
                let thisSlideDoneDate = null;
                let slideBeforeDone = "false";


                if (thisUserProgression) {
                    let thisSlideP = thisUserProgression.filter(progressEl => progressEl.playId.toString() === el.id.toString() && progressEl.playType === el.playType)[0]

                    if (thisSlideP) {
                        thisSlideDone = thisSlideP.done;
                        thisSlideDoneDate = thisSlideP.completionDate ? thisSlideP.completionDate : null;
                        thisSlideStartDate = thisSlideP.startDate ? thisSlideP.startDate : null;
                        if (i !== 0) {
                            let thisSlideBeforeP = thisUserProgression.filter(progressEl => progressEl.playId.toString() === orderedCourseSlidesData[i - 1].id.toString() && progressEl.playType === orderedCourseSlidesData[i - 1].playType)[0]
                            if (thisSlideBeforeP) {
                                slideBeforeDone = thisSlideBeforeP.done.toString();
                            }
                        }
                    }
                }

                let meetingRequestedLockedCondition = () => {
                    let locked = false;

                    if (userCourseRequestedMeetings) {
                        let reqMeeting = userCourseRequestedMeetings.find(meeting => meeting.courseModuleBlocked.toString() === el.id.toString() && meeting.courseModuleBlockedType === el.playType)

                        if (reqMeeting) {
                            console.log(reqMeeting)
                        }

                        if (reqMeeting && reqMeeting.blocked) {
                            locked = meetingsAvailableForThisModule(el.listIndex).length > 0
                        }

                    }
                    return locked
                }

                let meetingRequestAvailable = () => {

                    //**************************************************************************************************************** */
                    // before update - SHOW RESERVATION MEETING BUTTON BY DEFAULT EVEN IF THE MODULE RELATED WAS NOT COMPLETED
                    //**************************************************************************************************************** */
                    // let available = false;

                    // if (requestMeetingMode && userCourseRequestedMeetings) {
                    //     let reqMeeting = userCourseRequestedMeetings.find(meeting => meeting.courseModuleBlocked.toString() === el.id.toString() && meeting.courseModuleBlockedType === el.playType)

                    //     if (reqMeeting) {
                    //         available = true
                    //     }
                    // }
                    // return available



                    //**************************************************************************************************************** */
                    // after update - SHOW RESERVATION MEETING BUTTON BY DEFAULT EVEN IF THE MODULE RELATED WAS NOT COMPLETED
                    //**************************************************************************************************************** */
                    return meetingsAvailableForThisModule(el.listIndex).length > 0
                }

                let isAfterFirstReqMeetingBlocked = false;

                if (userCourseRequestedMeetings) {
                    if (userCourseRequestedMeetings.filter(el => el.blocked)[0]) {
                        //console.log(el.listIndex);
                        //console.log(userCourseRequestedMeetings.filter(el => el.blocked)[0]);
                        isAfterFirstReqMeetingBlocked = el.listIndex > userCourseRequestedMeetings.filter(el => el.blocked)[0].listIndex;
                    }
                }

                let continuousLockedCondition = (continuousMode && ((slideBeforeDone === 'false' && thisSlideDone === false && i > lastSlideDone) || isAfterFirstReqMeetingBlocked))

                let titleTime = () => {

                    let timeByType = [
                        {
                            type: ['video'],
                            time: el.time != null && el.time >= 1 ? fancyTimeFormat(el.time * 60) : '1 min +'
                        },
                        {
                            type: ['autoevaluation1', 'exercice', 'dndtext', 'dndmultiple', 'dndimages', 'calculation', 'rafale', 'exerciceopenquestion', 'exercicemultiplechoices'],
                            time: el.time != null && el.time >= 1 ? fancyTimeFormat(el.time * 60) : '15 min +'
                        },
                        {
                            type: ['exam', 'exammultiplechoice'],
                            time: el.duration != null && el.duration >= 1 ? fancyTimeFormat(el.duration * 60) : '30 min +'
                        },
                        {
                            type: ['scorm'],
                            time: el.time != null && el.time >= 1 ? fancyTimeFormat(el.time * 60) : '30 min +'
                        },
                        {
                            type: ['html', 'documents'],
                            time: el.time != null && el.time >= 1 ? fancyTimeFormat(el.time * 60) : '5 min +'
                        },
                    ]

                    let tTypeExist = timeByType.find(tType => tType.type.includes(el.playType));

                    return tTypeExist ? tTypeExist.time : null
                }

                el.thisSlideDone = thisSlideDone;
                el.thisSlideDoneDate = thisSlideDoneDate;
                el.thisSlideStartDate = thisSlideStartDate;
                el.blockedByProgression = continuousLockedCondition;
                el.blockedByReqMeeting = meetingRequestedLockedCondition();
                el.meetingAvailable = meetingRequestAvailable();
                el.titleTime = titleTime()

            })

            console.log(prev);

            return prev
        })

        setFilterAndSetMenuItemsConditionsDone(true)
    }

    const meetingsAvailableForThisModule = (thisModuleListIndex) => allMeetingReservations.filter(meetingEl => {
        const courseAvailabilityParsed = JSON.parse(meetingEl.courseAvailability);
        let courseModulesOrders = rawCoursesData.courses_modules.filter(el => courseAvailabilityParsed.courseModules.includes(el.modules_id.id.toString())).map(el => el.sort + 1);

        let thisCourseModuleEndOrder = thisModuleListIndex + 1;

        // console.log('courseAvailabilityParsed', courseAvailabilityParsed);
        // console.log('courseModulesOrders', courseModulesOrders);
        // console.log('thisCourseModuleEndOrder', thisCourseModuleEndOrder);

        if (courseModulesOrders.includes(thisCourseModuleEndOrder)) {
            return true
        } else {
            return false
        }
    })



    const handleNextSlide = (e) => {
        if (currentPlayContent.listIndex < orderedCourseSlidesData.length - 1) {
            console.log('handleNextSlide -  *********************************************************')
            filterAndSetMenuItemsConditions();
            console.log(userCourseRequestedMeetings)

            let sondageAvailable = allSondages.find(sondage =>
                sondage.status === 'published' &&
                sondage.prevModuleRelated &&
                sondage.prevModuleRelated.toString() === currentPlayContent.moduleContainerId &&
                !isSondageLocked(sondage)
            );

            scrollSlideMenuOnChange();
            refetchAllNotification();

            let nextSlide = orderedCourseSlidesData.find(el => el.listIndex === currentPlayContent.listIndex + 1);

            if (
                (!sondageAvailable && verifyModulesRequirementsConditionsBlocked(nextSlide)) ||
                verifyModulesHideOrBlockedModule(nextSlide) === 'blocked'
            ) {
                setMenuHidden(false);
                return;
            }

            while (verifyModulesHideOrBlockedModule(nextSlide) === 'hidden') {
                nextSlide = orderedCourseSlidesData.find(el => el.listIndex === nextSlide.listIndex + 1);
                if (verifyModulesHideOrBlockedModule(nextSlide) === 'blocked') {
                    setMenuHidden(false);
                    return;
                }
            }

            handleCurrentPlayChange({
                listIndex: nextSlide.listIndex,
                nextSlideEvent: true,
                sondage: sondageAvailable
            });
        }
    };

    const handleNextSlideFromSondage = (e) => {
        let currentListIndex = currentRunningSondage.prevModuleRelated ? orderedCourseSlidesData.find(el => el.moduleContainerId.toString() === currentRunningSondage.prevModuleRelated.toString()).listIndex : null;

        if (currentListIndex < orderedCourseSlidesData.length - 1) {
            console.log('handleNextSlideFromSondage -  *********************************************************')
            console.log(currentListIndex)
            filterAndSetMenuItemsConditions();
            console.log(userCourseRequestedMeetings)
            handleCurrentPlayChange({ listIndex: currentListIndex === null ? 0 : currentListIndex + 1, nextSlideEvent: true })
            setCurrentRunningSondage(null);
            setCurrentRunningSondageAnswers([]);
            scrollSlideMenuOnChange();
            refetchAllNotification();
            refetchSondagesAnswers();
        }
    };

    const updateCurrentUserProgression = (resetThisModule = true, failedAndRequestMeeting = false, done = true, instantDone = false) => {

        console.log('Entering updateCurrentUserProgression');

        let courseName = rawCoursesData.course_tag
        let newProgress = { ...userCourseProgression };

        console.log('setUserCourseProgression');
        console.log(newProgress);

        if (newProgress[courseName] && currentPlayContent.id) {
            console.log(currentPlayContent)
            let indexOfCurrentPlay = newProgress[courseName].findIndex(el => el.playId.toString() === currentPlayContent.id.toString() && el.playType === currentPlayContent.playType);
            let playReqMeetingBlocked = newProgress[courseName][indexOfCurrentPlay + 1] ? newProgress[courseName][indexOfCurrentPlay + 1] : null;

            // console.log(playReqMeetingBlocked);
            // console.log(newProgress[courseName][indexOfCurrentPlay]);
            // console.log(newProgress[courseName][indexOfCurrentPlay + 1]);

            newProgress[courseName][indexOfCurrentPlay].done = newProgress[courseName][indexOfCurrentPlay].done ? newProgress[courseName][indexOfCurrentPlay].done : done;

            if (!teamsFiltersEnabled || !contactTeamSelected) {
                newProgress[courseName][indexOfCurrentPlay].listIndex = currentPlayContent.listIndex;
            }

            console.log('moment(new Date())');
            console.log(moment(new Date()));
            console.log('moment()');
            console.log(moment());
            // KEEP timezone here as'America/New_York' to avoid timezone issues with date in DB
            if (instantDone) {
                if (done) {
                    newProgress[courseName][indexOfCurrentPlay].startDate = moment().tz('America/New_York').format("YYYY-MM-DD HH:mm:ss");
                    newProgress[courseName][indexOfCurrentPlay].completionDate = moment().tz('America/New_York').format("YYYY-MM-DD HH:mm:ss");
                    failedAndRequestMeeting = true;
                }
            } else {
                if (done) {
                    newProgress[courseName][indexOfCurrentPlay].completionDate = moment().tz('America/New_York').format("YYYY-MM-DD HH:mm:ss");
                    failedAndRequestMeeting = true;
                } else {
                    newProgress[courseName][indexOfCurrentPlay].startDate = moment().tz('America/New_York').format("YYYY-MM-DD HH:mm:ss");
                }
            }

            if (resetThisModule) {
                setResetModule(true)
            }

            if (!updateProgressionLoading) {
                console.log('Calling updateProgression mutation');

                updateProgression({
                    variables: {
                        studentId: state.userInfos.id,
                        studentName: state.userInfos.firstName + " " + state.userInfos.lastName,
                        courseName: courseName,
                        progressionJson: JSON.stringify(newProgress[courseName]),
                        ...(failedAndRequestMeeting && playReqMeetingBlocked && meetingsAvailableForThisModule(indexOfCurrentPlay + 1).length > 0 ? { requestedMeetingModule: JSON.stringify({ id: playReqMeetingBlocked.playId, type: playReqMeetingBlocked.playType }) } : {})
                    }
                });
            }

            if (done && allCertificatesConfigurations && allCertificatesConfigurations.length > 0) {
                console.log('Calling addEarnedCertificate mutation');

                addEarnedCertificate({
                    variables: {
                        studentId: typeof state.userInfos.id === 'string' ? parseInt(state.userInfos.id) : state.userInfos.id,
                        courseName: courseName,
                        moduleIdRelated: typeof currentPlayContent.moduleContainerId === 'string' ? parseInt(currentPlayContent.moduleContainerId) : currentPlayContent.moduleContainerId,
                    }
                })
            }
        }

        setUserCourseProgression(newProgress)
        refetchAllNotification();

    }

    const handleSlideDoneFromVideo = (e) => {
        setVideoDone(true);
        setReplayVideoAvailable(true);
    };

    const scrollSlideMenuOnChange = () => {
        let countVoid = 0

        const interval = setInterval(() => {
            const currentEl = document.querySelector('.current-play-el')
            if (currentEl) {
                document.querySelector('.play-list-menu > ul').scrollTop = currentEl.offsetTop - (currentEl.offsetHeight * 2 + 50);
                clearInterval(interval)
            }
            if (countVoid >= 10) {
                clearInterval(interval)
            }
            countVoid++
        }, 200);

    }

    const toggleSearchMenuInput = () => {
        setDisplaySearchMenu(prev => !prev);
        scrollSlideMenuOnSearchChange('')
    }

    const scrollSlideMenuOnSearchChange = (searchText) => {

        if (searchText && searchText.trim().length > 0) {
            let countVoid = 0
            const allMenuTitleContainingSearch = [...document.querySelectorAll('.play-el')].filter(div => div.querySelector('.list-title-text').innerHTML.toLowerCase().includes(searchText.toLowerCase()));
            const notSearchedMenuItems = [...document.querySelectorAll('.play-el')].filter(div => !div.querySelector('.list-title-text').innerHTML.toLowerCase().includes(searchText.toLowerCase()));

            if (allMenuTitleContainingSearch.length > 0) {
                const interval = setInterval(() => {
                    const seletedEl = allMenuTitleContainingSearch[0]
                    if (seletedEl) {
                        document.querySelector('.play-list-menu > ul').scrollTop = seletedEl.offsetTop - (seletedEl.offsetHeight * 2 + 50);

                        clearInterval(interval)
                    }
                    if (countVoid >= 10) {
                        clearInterval(interval)
                    }
                    countVoid++
                }, 200);

                allMenuTitleContainingSearch.map(selectSearch => {
                    selectSearch.querySelector('.list-title-text').classList.add("list-title-text-searched")
                })
            }

            notSearchedMenuItems.map(notSearch => {
                notSearch.querySelector('.list-title-text').classList.remove("list-title-text-searched")
            })
        } else {
            [...document.querySelectorAll('.play-el')].map(notSearch => {
                notSearch.querySelector('.list-title-text').classList.remove("list-title-text-searched")
            })
        }

    }

    const handleCurrentPlayChange = ({ listIndex, forceDisplayMeetingPage = false, nextSlideEvent = false, sondage = null }) => {

        if (sondage) {
            if (introPageSkipped) window.history.pushState("", "", (process.env.REACT_APP_ENV === 'production' ? '' : '/dev') + "/formation/?tag=" + parsedQuery.tag + '&skipIntro=' + true + '&sondageId=' + sondage.id);

            setCurrentRunningSondage(sondage)
            setCurrentRunningSondageAnswers(allSondagesAnswers.filter(el => el.sondageId.toString() === sondage.id))
            handleCloseDeskptoMenu()
            setResetModule(true);
        } else {
            if (introPageSkipped) window.history.pushState("", "", (process.env.REACT_APP_ENV === 'production' ? '' : '/dev') + "/formation/?tag=" + parsedQuery.tag + '&skipIntro=' + true);
            setCurrentRunningSondage(null);
            setCurrentRunningSondageAnswers([])

            let selectedSlide = orderedCourseSlidesData.filter(item => item.listIndex === listIndex)[0];
            let isDisplayMeetingSection = false;

            // ******************************************************************
            // Display additional information modal
            if (selectedSlide.additionalInformation) {
                handleShowAdditionalInformationModal(selectedSlide.additionalInformation)
            }
            // ******************************************************************

            // ******************************************************************
            // CUSTOM CONDITION TO DISPLAY WEBZONE MODULE IN CONTACT
            if (!state.userInfos.webzone && ['goBRIOestmonoutildetravailprincipalexterne'].includes(parsedQuery.tag) && `${selectedSlide.id}_${selectedSlide.playType}` === '264_documents') {
                selectedSlide = orderedCourseSlidesData.filter(item => item.listIndex === listIndex + 1)[0];
            }
            // CUSTOM CONDITION TO DISPLAY WEBZONE MODULE IN CONTACT
            // ******************************************************************

            if (selectedSlide.blockedByProgression) {
                let filteredNotBlockedByProgression = orderedCourseSlidesData.filter(item => !item.blockedByProgression)
                selectedSlide = filteredNotBlockedByProgression[filteredNotBlockedByProgression.length - 1]
            }


            console.log('userCourseRequestedMeetings', userCourseRequestedMeetings);
            console.log('forceDisplayMeetingPage', forceDisplayMeetingPage);
            console.log('nextSlideEvent', nextSlideEvent);
            console.log('allMeetingReservations', allMeetingReservations);

            if (forceDisplayMeetingPage || (meetingsAvailableForThisModule(listIndex).length > 0 && nextSlideEvent)) {
                let reqMeeting = userCourseRequestedMeetings ? userCourseRequestedMeetings.find(reqMeeting => reqMeeting.courseModuleBlocked.toString() === selectedSlide.id.toString() && reqMeeting.courseModuleBlockedType === selectedSlide.playType) : null;
                console.log('reqMeeting', reqMeeting)
                setResetModule(true);
                setTimeout(() => {
                    setResetModule(false);
                }, 1000)
                isDisplayMeetingSection = true;
                window.history.pushState("", "", (process.env.REACT_APP_ENV === 'production' ? '' : '/dev') + "/formation/?tag=" + parsedQuery.tag + '&skipIntro=' + true + '&playId=' + selectedSlide.id + '&playType=' + selectedSlide.playType);
                setSelectedCourseReqMeeting(reqMeeting ? reqMeeting : { courseModuleBlocked: selectedSlide.id, courseModuleBlockedType: selectedSlide.playType, blocked: false, listIndex: listIndex })
                setMenuHidden(false);
                setCurrentPlayContent({ listIndex: listIndex, typeToSendMeeting: selectedSlide.playType });
                // console.log(reqMeeting.listIndex)
            }



            if (!isDisplayMeetingSection) {
                handleCloseDeskptoMenu()
                if (['scorm', 'video', 'dndimages', 'dndmultiple', 'dndtext', 'exam', 'exammultiplechoice', 'exercice', 'exerciceopenquestion', 'exercicemultiplechoices', 'calculation', 'rafale'].includes(selectedSlide['playType'])) {
                    if (selectedSlide.question) {
                        if (selectedSlide.question && selectedSlide.question[0].sort === null) {
                            selectedSlide.question = selectedSlide.question.map((item, index) => {
                                return ({ ...item, sort: index + 1 })
                            });
                        }
                    }

                }

                setCurrentPlayContent(selectedSlide);
                setVideoDone(false);
                setReplayVideoAvailable(false);
                setResetModule(true);
                handleMobileClosePlayListMenu();
                setStartSlideFromIntro(false);
            }

            setDisplayMeetingSection(isDisplayMeetingSection);
        }
    };

    const handleCloseDeskptoMenu = () => {
        setMenuHidden(true)
        setShowMenuBtnTooltip(true)
        setTimeout(() => {
            setShowMenuBtnTooltip(false)
        }, 2000)
    }

    const handleMobileClosePlayListMenu = e => {
        setPlayListMobileMenuClass('play-list-menu-mobile');
        setPlayListMobileMenuBtn(faList);
    };

    const handleMobileOpenClosePlayListMenu = e => {
        if (playListMobileMenuClass.indexOf('play-list-menu-mobile-open') !== -1) {
            setPlayListMobileMenuClass('play-list-menu-mobile');
            setPlayListMobileMenuBtn(faList);
        } else {
            setPlayListMobileMenuClass('play-list-menu-mobile play-list-menu-mobile-open');
            setPlayListMobileMenuBtn(faTimes);
        }
    };

    const handleSkipIntro = () => {
        setIntroPageSkipped(true)
        scrollSlideMenuOnChange();
    }

    const handleSkipIntroAndGoToSlide = (listIndex) => {
        setIntroPageSkipped(true);
        handleCurrentPlayChange({ listIndex })
        scrollSlideMenuOnChange();
    }

    const handleReturnToIntro = () => {
        window.history.replaceState("", "", (process.env.REACT_APP_ENV === 'production' ? '' : '/dev') + "/formation/?tag=" + parsedQuery.tag + '&skipIntro=' + false);
        setIntroPageSkipped(false);
        setStartSlideFromIntro(true);
        setMenuHidden(false);
    }

    const handleFilterModulesByTeamFilters = (teamLabel, backupOrderedCourseSlidesData) => {
        console.log('handleFilterModulesByTeamFilters', orderedCourseSlidesData);
        console.log('backupOrderedCourseSlidesData', backupOrderedCourseSlidesData);
        console.log('teamLabel', teamLabel);

        if (teamLabel) {
            localStorage.setItem('courseTeamSelected', teamLabel);
        } else {
            localStorage.removeItem('courseTeamSelected');
        }

        var safeUrl = DOMPurify.sanitize((process.env.REACT_APP_ENV === 'production' ? '' : '/dev') + '/formation/?tag=' + parsedQuery.tag + '&skipIntro=false', { ALLOWED_URI_REGEXP: /^(https?|ftp):/ });

        window.location.href = safeUrl
    }


    const verifyModulesRequirementsConditionsBlocked = (module) => {

        if (modulesRequirementsConditions) {

            const modulesRequired = modulesRequirementsConditions.filter(el => el.module_blocked.toString() === module.moduleContainerId).map(el => el.modules_required).flat();

            return userCourseProgression[rawCoursesData.course_tag].filter(el => modulesRequired.includes(el.moduleContainerId) && !el.done).length > 0
        } else {
            return false
        }
    };

    const verifyModulesHideOrBlockedModule = (module) => {
        const { cohortes } = state.userInfos;
        const moduleKey = `${module.moduleContainerId}_${rawCoursesData.course_tag}`;


        for (const cohorte of cohortes) {
            if (cohorte.blockedModules && cohorte.blockedModules[moduleKey]) {
                const blockHideEl = cohorte.blockedModules[moduleKey];

                if (blockHideEl.date) {
                    const [startDate, endDate] = blockHideEl.date;
                    const today = momentInUserTimezone().startOf('day');

                    const startOfDay = momentInUserTimezone(startDate).startOf('day');
                    const endOfDay = momentInUserTimezone(endDate).endOf('day');

                    if (today.isBetween(startOfDay, endOfDay, null, '[]')) {
                        return blockHideEl.action;
                    }
                } else {
                    return blockHideEl.action;
                }
            }
        }

        return null;
    };


    const modulesRequirementsConditionsBlockedListIndexes = (module) => {

        if (modulesRequirementsConditions) {

            const modulesRequired = modulesRequirementsConditions.filter(el => el.module_blocked.toString() === module.moduleContainerId).map(el => el.modules_required).flat();

            return orderedCourseSlidesData.filter(el => modulesRequired.includes(el.moduleContainerId)).map(el => el.listIndex + 1).join(', ');
        } else {
            return null
        }
    }


    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = () => setShowModal(true);
    const handleCloseAdditionalInformationModal = () => {
        setAdditionalInformationModalContent(null);
        setShowAdditionalInformationModal(false)
    };
    const handleShowAdditionalInformationModal = (content) => {
        setAdditionalInformationModalContent(content);
        setShowAdditionalInformationModal(true)
    };
    const handleCloseModalContactFiltersTeam = () => setShowModalContactFiltersTeam(false);
    const handleShowModalContactFiltersTeam = () => setShowModalContactFiltersTeam(true);

    const documentsAndNotesManual = (
        <DocumentsAndNotesManual
            studentGuideButtonDisabled={rawCoursesData.studentGuideButtonDisabled}
            courseData={orderedCourseSlidesData}
            courseTitle={rawCoursesData['course_title']}
            courseDocuments={rawCoursesData['documents']} />
    )

    const handleOpenCloseChatbot = () => {
        if (minimizedChatBox === false) {
            setDisplayChatBotBox(prev => !prev)
        } else {
            setMinMaxChatBotBox(prev => !prev)
        }
    }

    const handleMinMaxChatBotBox = () => {
        setMinMaxChatBotBox(prev => !prev)
    }

    const customDisplayOptionnalLabel = (module) => {

        const conditionsCourseTag = [
            "JesoutienslesgensquiutilisentgoBRIOauquotidien",
            "JaidesbesoinsspcifiquesdansgoBRIO",
            "JesoutienslesgensquiutilisentgoBRIOauquotidienexterne"
        ];

        const conditionsModules = [
            "1120_scorm",
            "1121_scorm",
            "1122_scorm",
            "1143_scorm",
            "1144_scorm",
            "1145_scorm",
            "1049_scorm",
            "1146_scorm",
            "1147_scorm",
            "1148_scorm",
            "1050_scorm",
            "1051_scorm",
            "1052_scorm",
            "1053_scorm",
            "1123_scorm",
            "1124_scorm",
            "1125_scorm",
            "1126_scorm",
            "1128_scorm",
            "1127_scorm",
            "1129_scorm",
            "1150_scorm",
            "1151_scorm",
            "1152_scorm",
        ]


        if (conditionsCourseTag.includes(rawCoursesData.course_tag) && conditionsModules.includes(`${module.id}_${module.playType}`)) {
            return "(Optionnelle)"
        } else {
            return ""
        }

    }


    const mobileNotCompatible = <div style={{ textAlign: 'center', fontSize: 20, padding: 15, color: 'red' }}>Veuillez faire cette activité sur un ordinateur.</div>;

    const menuHiddenContentClass = (menuHidden ? 'content-wide' : '')

    if (loadingData || loadingProgression || !currentPlayContent) return (<div className="fallback-black-loader course-play-loader"><MoonLoader color={'#cd1236'} /></div>);


    const isSondageLocked = (sondage, previousModuleDone, previousModuleDoneDate) => {


        const reportingByCohortes = sondage.reportingByCohortes ? JSON.parse(sondage.reportingByCohortes) : [];
        const reportingGeneral = sondage.reportingGeneral ? JSON.parse(sondage.reportingGeneral) : {};


        const now = momentInUserTimezone();

        const studentCohortesId = state.userInfos.cohortes.reduce((acc, cohorte) => {
            if (cohorte.course === rawCoursesData.course_tag && sondage.reportingByCohortes.includes(cohorte.cohorteID)) {
                acc.push(cohorte.cohorteID);
            }
            return acc;
        }, []);


        let lockDate = null;


        console.log('studentCohortesId', studentCohortesId)

        if (studentCohortesId && studentCohortesId.length > 0) {
            let cohorLock = null;
            let pastDateFound = false;

            reportingByCohortes.some((reporting) => {
                if (reporting.cohortes.some(cohorte => studentCohortesId.includes(cohorte))) {
                    if (reporting.studentSendDate) {
                        if (reporting.accessRestriction === 'dateAssigned') {
                            const studentSendDate = momentInUserTimezone(reporting.studentSendDate);
                            if (now.isBefore(studentSendDate) && !pastDateFound) {
                                cohorLock = cohorLock === null || studentSendDate.isBefore(cohorLock) ? studentSendDate : cohorLock;
                            } else if (now.isSameOrAfter(studentSendDate)) {
                                cohorLock = null;
                                pastDateFound = true;
                                return true;
                            }
                        }
                        if (reporting.accessRestriction === 'prevModuleCompletion') {
                            cohorLock = !previousModuleDone;
                            pastDateFound = true;
                            return true;
                        }

                        if (reporting.accessRestriction === 'prevModuleCompletionWithDelay') {
                            if (
                                previousModuleDoneDate
                            ) {
                                const futureDate = momentInUserTimezone(previousModuleDoneDate).add(reporting.moduleCompletionDelayDays, 'days');
                                if (momentInUserTimezone().isBefore(futureDate, 'day')) {
                                    cohorLock = futureDate;
                                } else {
                                    cohorLock = null;
                                }

                                pastDateFound = true;
                                return true;
                            } else {
                                cohorLock = true;
                                pastDateFound = true;
                                return true;
                            }
                        }

                        if (!reporting.accessRestriction || reporting.accessRestriction === 'noRestriction') {
                            cohorLock = null;
                            pastDateFound = true;
                            return true;
                        }
                    }
                }
                return false;
            });

            lockDate = cohorLock;
        } else {
            if (reportingGeneral.accessRestriction === 'dateAssigned') {
                lockDate = momentInUserTimezone(reportingGeneral.studentSendDate);
            }

            if (reportingGeneral.accessRestriction === 'prevModuleCompletion') return !previousModuleDone;

            if (reportingGeneral.accessRestriction === 'prevModuleCompletionWithDelay') {
                if (
                    previousModuleDoneDate
                ) {
                    const futureDate = momentInUserTimezone(previousModuleDoneDate).add(reportingGeneral.moduleCompletionDelayDays, 'days');
                    if (momentInUserTimezone().isBefore(futureDate, 'day')) {
                        lockDate = futureDate;
                    } else {
                        return false
                    }
                } else {
                    return true;
                }
            }

            if (!reportingGeneral.accessRestriction || reportingGeneral.accessRestriction === 'noRestriction') {
                return false;
            }

        }

        return lockDate;
    }

    const sondageMenuListItem = ({
        currentRunningSondage,
        sondage,
        index,
        previousModuleDone,
        previousModuleDoneDate
    }) => {

        const isLockedDate = isSondageLocked(sondage, previousModuleDone, previousModuleDoneDate);

        const isCurrentSlide = currentRunningSondage && currentRunningSondage.id === sondage.id

        const isSlideDone = allSondagesAnswers.some(sondageAnswer => sondageAnswer.sondageId.toString() === sondage.id);

        const getIcon = () => {
            if (isSlideDone) {
                return <FontAwesomeIcon className={'done-check'} icon={faCheckCircle} />;
            }

            if (isLockedDate) {
                return <FontAwesomeIcon className={'not-done-lock'} icon={faLock} />;
            }

            return isCurrentSlide ? <div className={'current-check'}></div> : <div className={'not-done-check'}></div>;
        };

        if (!introPageSkipped) {
            var safeUrl = DOMPurify.sanitize((process.env.REACT_APP_ENV === 'production' ? '' : '/dev') + '/formation/?tag=' + parsedQuery.tag + '&skipIntro=true&sondageId=' + sondage.id, { ALLOWED_URI_REGEXP: /^(https?|ftp):/ });

            return (
                <a key={index + 'sondage'} href={!isLockedDate ? safeUrl : null} className={'list-item-sondage-link'}>
                    <div className={'list-item list-item-sondage'}>
                        <div className={'list-title'}>
                            <div className={'done-cnt'}>
                                {
                                    !isLockedDate && (
                                        isSlideDone ? <FontAwesomeIcon className={'done-check'} icon={faCheckCircle} /> : <div className={'not-done-check'}></div>
                                    )
                                }

                                {isLockedDate && <FontAwesomeIcon className={'not-done-lock'} icon={faLock} />}

                            </div>

                            <p>
                                {sondage.title}
                            </p>
                        </div>

                        <div className={'list-infos'}>
                            <div className={'list-type-icon'}>
                                <FontAwesomeIcon icon={faStar} />
                            </div>

                            <div className={'list-time'}>
                                <FontAwesomeIcon icon={faClock} />
                                <span>{fancyTimeFormat(sondage.time * 60)}</span>
                            </div>
                        </div>
                    </div>
                </a >
            )
        }

        return (
            <li
                key={index + 'sondage'}
                className={isCurrentSlide ? 'current-play-el play-el' : 'play-el'}
                done={isSlideDone ? 'true' : 'false'}
                style={isLockedDate ? { opacity: 0.7 } : {}}
                onClick={() => !isLockedDate ? handleCurrentPlayChange({ sondage }) : console.log('sondage locked')}>
                {/* <span className={'slide-number'}>*</span> */}

                {
                    getIcon()
                }

                <span className={'list-title'}>
                    <FontAwesomeIcon className={'list-type-icon'} icon={faStar} />
                    <span className={'list-title-text'}>{sondage.title}</span>
                    <span className={'list-title-time'}>{'(' + fancyTimeFormat(sondage.time * 60) + ')'}</span>

                    {
                        (isLockedDate && momentInUserTimezone(isLockedDate).isValid()) && (
                            <span className={'list-title-prerequis-text'}>
                                {state.lang === 'fr' ? 'Disponible le' : 'Available'}
                                <br />
                                {momentInUserTimezone(isLockedDate).format("dddd, Do MMMM  YYYY")}
                            </span>
                        )
                    }

                </span>
            </li>
        )
    }

    return (
        <div className={'course-play-page'}>
            <h1 className='d-none'>{rawCoursesData['course_title']}</h1>

            {
                chatBotAvailable && displayChatBotBox ?
                    <div className={"chatbot-box" + " " + (minimizedChatBox ? "chatBot-is-min" : "chatBot-is-max")}>
                        <ChatBotIcite
                            chatBotQuestions={chatBotQuestions}
                            chatBotEmailRecipients={chatBotEmailRecipients}
                            courseName={parsedQuery.tag}
                            lang={state.lang}
                            userInfos={state.userInfos}
                            handleMinMaxChatBotBox={handleMinMaxChatBotBox}
                            handleOpenCloseChatbot={handleOpenCloseChatbot} />
                    </div> : null
            }

            {
                chatBotAvailable ?
                    <TooltipAntd placement="topLeft" title={"Question ?"} open={showChatBotTooltip === 1}>
                        <div className={"chatbot-icon-cnt"} onClick={handleOpenCloseChatbot}>
                            {minimizedChatBox === true ?
                                <div className={"chatbot-min-icon"} >
                                    <FontAwesomeIcon icon={faCommentDots} />
                                </div>
                                : ""
                            }
                            <FontAwesomeIcon icon={faRobot} className={"chatbot-icon"} />
                        </div>
                    </TooltipAntd> : null
            }

            <div>

            </div>


            <FontAwesomeIcon className={'mobile-play-list-btn ' + (!introPageSkipped ? 'd-none' : '')} icon={playListMobileMenuBtn} onClick={handleMobileOpenClosePlayListMenu} />

            <div ref={targetMenuBtnTooltip} className={'open-hidden-menu-btn ' + (menuHidden && introPageSkipped ? 'open-hidden-menu-btn-visible' : '')} onClick={() => (setMenuHidden(false))}>
                <FontAwesomeIcon icon={faList} />
            </div>

            <Overlay target={targetMenuBtnTooltip.current} show={showMenuBtnTooltip && introPageSkipped} placement="right">
                {(props) => (
                    <Tooltip id="overlay-example" {...props}>
                        {t('coursePlayClickOnIcon')}

                    </Tooltip>
                )}
            </Overlay>

            {/***************************************************/}
            {/*REMOVE TOP MENU WHEN COURSE IS PLAYED*/}
            {/***************************************************/}
            {
                !introPageSkipped ? <style dangerouslySetInnerHTML={{ __html: `.menu-top-container { display: block }` }} /> : <style dangerouslySetInnerHTML={{ __html: `.menu-top-container { display: none }` }} />
            }

            {/***************************************************/}
            {/*DISPLAY INTRO PAGE OR COURSE-PLAY PAGE*/}
            {/***************************************************/}
            {
                !introPageSkipped ?
                    (
                        <CourseIntro
                            skipIntroAndGoToSlide={handleSkipIntroAndGoToSlide}
                            skipIntro={handleSkipIntro}
                            continuousMode={continuousMode}
                            courseData={rawCoursesData}
                            allSondages={allSondages}
                            allSondagesAnswers={allSondagesAnswers}
                            allCertificates={allCertificates}
                            generateCetificatePdf={generateCetificatePdf}
                            currentRunningSondage={currentRunningSondage}
                            sondageMenuListItem={sondageMenuListItem}
                            lastSlideDone={lastSlideDone}
                            userCourseProgression={userCourseProgression[rawCoursesData.course_tag]}
                            orderedCourseSlidesData={orderedCourseSlidesData}
                            progressPercentage={progressPercentage}
                            customDisplayOptionnalLabel={customDisplayOptionnalLabel}
                            verifyModulesHideOrBlockedModule={verifyModulesHideOrBlockedModule}
                            verifyModulesRequirementsConditionsBlocked={verifyModulesRequirementsConditionsBlocked}
                            modulesRequirementsConditionsBlockedListIndexes={modulesRequirementsConditionsBlockedListIndexes}
                            bannerFullHeight={bannerFullHeight} />
                    )
                    :
                    (
                        <div className={'play-container'}>

                            {/***************************************************/}
                            {/*COURSE'S SLIDES LEFT MENU*/}
                            {/***************************************************/}
                            <div className={'play-list-menu ' + playListMobileMenuClass + ' ' + (isMobile ? '' : menuHidden ? 'menu-hidden' : '')}>
                                <div className={'progression'}>
                                    <div className={'back-btn'} onClick={handleReturnToIntro} title={t('course-play-page-return-btn')}>
                                        <FontAwesomeIcon className={'back-icon'} icon={faHouse} title={t('course-play-page-return-btn')} />
                                    </div>

                                    <div className={'hide-menu-btn'} onClick={() => handleCloseDeskptoMenu()}>
                                        <FontAwesomeIcon icon={faClose} />
                                    </div>


                                    <div className={'search-btn'} onClick={toggleSearchMenuInput} title={t('course-play-page-search-btn-label')}>
                                        <FontAwesomeIcon className={'search-icon'} icon={faSearch} title={t('course-play-page-search-btn-label')} />
                                    </div>

                                    {
                                        (rawCoursesData.documents && rawCoursesData.documents.length > 0) || (!rawCoursesData.studentGuideButtonDisabled) ?
                                            <div className={'documents-btn'} onClick={handleShowModal} title={t('course-play-page-documents-btn-label')}>
                                                <FontAwesomeIcon className={'documents-icon'} icon={faBook} title={t('course-play-page-documents-btn-label')} />
                                            </div> : null
                                    }

                                    <p className={'course-title'} >{rawCoursesData['course_title']}</p>
                                    <div className={'progress-bar'}>
                                        <div className={'progress-bar-inside'} style={{ width: progressPercentage + '%' }}> </div>
                                    </div>
                                    <div className={'progress-number'}>
                                        {progressPercentage} % {t('course-play-page-progress-done')}
                                    </div>
                                </div>

                                {
                                    displaySearchMenu ?
                                        (
                                            <div className={'search-input-cnt'}>
                                                <input type="text"
                                                    autoFocus
                                                    onBlur={() => {
                                                        setTimeout(() => {
                                                            toggleSearchMenuInput()
                                                        }, 400)
                                                    }}
                                                    onChange={e => scrollSlideMenuOnSearchChange(e.target.value)}
                                                    className={'search-input'}
                                                    placeholder={t('course-play-page-search-btn-label')} />
                                            </div>
                                        ) : null
                                }

                                {
                                    teamsFiltersEnabled && (
                                        <div className={'team-select-dropdown-cnt'}>

                                            <p className={'team-select-dropdown-title'}>
                                                {
                                                    !contactTeamSelected ?
                                                        (rawCoursesData.course_tag === "ADPParcoursinitialsouscripteursPrestigeautomobileethabitation" ? t('filter-message-3') + teamsFiltersModalTexts.lowerCase + t('filter-message-4') : t('filter-message-1') + teamsFiltersModalTexts.lowerCase + t('filter-message-2'))
                                                        :
                                                        (teamsFiltersModalTexts.capitalised + t('selected'))
                                                }
                                            </p>

                                            <Select
                                                className={'team-select-dropdown'}
                                                showSearch
                                                filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                style={{ width: '100%' }}
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                listHeight={500}
                                                placeholder={t('filter-placeholder')}
                                                value={contactTeamSelected}
                                                onChange={(val) => handleFilterModulesByTeamFilters(val, backupOrderedCourseSlidesData)}>
                                                {
                                                    teamsFilters.map((team, tIndex) => {
                                                        return (
                                                            <Option key={team.teamLabel}>{team.teamLabel}</Option>
                                                        )
                                                    })
                                                }
                                            </Select>
                                        </div>
                                    )
                                }


                                <ul>
                                    {
                                        orderedCourseSlidesData.map((el, i) => {

                                            let openNoteBtnClass = allNotesEditorContent[el.id] ? allNotesEditorContent[el.id]['blocks'][0]['text'].length > 0 ? 'open-note-available' : '' : ''
                                            let currentPlayClassConditionWithMeeting = selectedCourseReqMeeting ? el.listIndex === selectedCourseReqMeeting.listIndex && displayMeetingSection : false;
                                            let currentPlayClassCondition = el.listIndex === currentPlayContent.listIndex && currentRunningSondage === null ? 'current-play-el play-el' : 'play-el';

                                            // ******************************************************************
                                            // CUSTOM CONDITION TO DISPLAY WEBZONE MODULE IN CONTACT
                                            if (!state.userInfos.webzone && ['goBRIOestmonoutildetravailprincipalexterne'].includes(parsedQuery.tag) && `${el.id}_${el.playType}` === '264_documents') return null;
                                            // CUSTOM CONDITION TO DISPLAY WEBZONE MODULE IN CONTACT
                                            // ******************************************************************

                                            // ******************************************************************
                                            // CONDITION for HIDE OR BLOCKED MODULE based on cohortes conditions
                                            const hideOrBlockedModule = verifyModulesHideOrBlockedModule(el);

                                            if (hideOrBlockedModule === 'hidden') return null;
                                            // ******************************************************************
                                            // CUSTOM  for HIDE OR BLOCKED MODULE based on cohortes conditions


                                            const blockedModuleRequiredCondition = verifyModulesRequirementsConditionsBlocked(el);
                                            const blockedModuleRequiredConditionListIndexes = blockedModuleRequiredCondition ? modulesRequirementsConditionsBlockedListIndexes(el) : null;

                                            const isCurrentPlayClass = !currentPlayClassConditionWithMeeting && currentPlayClassCondition;
                                            const isDivision = el.playType === 'division';
                                            const isSubDivision = el.sub_division;
                                            const isSlideDone = el.thisSlideDone ? 'true' : el.thisSlideStartDate ? 'partially' : 'false';
                                            const isBlocked = blockedModuleRequiredCondition || el.blockedByProgression || hideOrBlockedModule === 'blocked';
                                            const opacity = blockedModuleRequiredCondition ? 1 : 0.5;
                                            const canChangePlay = currentPlayContent.listIndex !== el.listIndex || displayMeetingSection || currentRunningSondage !== null;
                                            const handleClick = param => canChangePlay && !isBlocked ? handleCurrentPlayChange({ listIndex: el.listIndex }) : console.log('click on current content');

                                            return (
                                                <>

                                                    {
                                                        i === 0 &&
                                                        allSondages &&
                                                        allSondages.length > 0 &&
                                                        allSondages
                                                            .filter(sondage => sondage.status === 'published' && sondage.prevModuleRelated === null)
                                                            .map((sondage, i) => (
                                                                sondageMenuListItem({
                                                                    currentRunningSondage,
                                                                    sondage,
                                                                    index: i,
                                                                    previousModuleDone: true
                                                                })
                                                            ))
                                                    }

                                                    {
                                                        el.meetingAvailable && (
                                                            <li
                                                                key={i + 'tMeeting'}
                                                                className={(currentPlayClassConditionWithMeeting && currentPlayClassCondition) + ' play-el-division-meeting'}
                                                                done={el.thisSlideDone ? 'true' : el.thisSlideStartDate ? 'partially' : 'false'}
                                                                style={blockedModuleRequiredCondition || el.blockedByProgression ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                                                                onClick={param => currentPlayContent.listIndex !== el.listIndex || !displayMeetingSection ? handleCurrentPlayChange({ listIndex: el.listIndex, forceDisplayMeetingPage: true }) : console.log('click on current content')}
                                                            >
                                                                <span className={'list-title'}>
                                                                    {/* Titre */}
                                                                    <span style={{ color: '#c60c30', fontSize: 15, fontWeight: 'bold', lineHeight: '17px', padding: '0 0 10px 0', textAlign: 'left', display: 'block', margin: '0 5px 0 0' }}>
                                                                        {
                                                                            t('course-intro-page-course-virtual-meeting-suggested')
                                                                        }
                                                                    </span>
                                                                    {/* Bouton "M'inscrire" */}
                                                                    <span style={{ backgroundColor: '#c60c30', color: '#fff', fontSize: 14, borderRadius: '5px', padding: '15px', textAlign: 'left', display: 'block', margin: '0 5px 0 0', width: 'fit-content' }}>
                                                                        <span style={{ margin: '0 10px 0 0' }}>
                                                                            <FontAwesomeIcon size='lg' icon={faCalendarAlt} title={t('course-intro-page-course-virtual-meeting-btn-label')} /></span>
                                                                        {t('course-intro-page-course-virtual-meeting-suggested-btn')}</span>
                                                                </span>
                                                            </li>
                                                        )
                                                    }

                                                    <li
                                                        key={i + 't'}
                                                        className={`${isCurrentPlayClass} ${isDivision ? (isSubDivision ? 'play-el-division-sub' : 'play-el-division') : ''}`}
                                                        done={isSlideDone}
                                                        style={isBlocked ? { opacity } : {}}
                                                        onClick={handleClick}
                                                    >
                                                        <span className={'slide-number'}>{i + 1}</span>

                                                        {
                                                            el.blockedByReqMeeting ?
                                                                null
                                                                :
                                                                el.thisSlideDone === true ?
                                                                    <FontAwesomeIcon className={'done-check'} icon={faCheckCircle} />
                                                                    : <div className={'current-check'}></div>
                                                        }

                                                        {
                                                            (
                                                                blockedModuleRequiredCondition ||
                                                                el.blockedByProgression ||
                                                                hideOrBlockedModule === 'blocked' ||
                                                                el.blockedByReqMeeting
                                                            ) ?
                                                                <FontAwesomeIcon className={'not-done-lock'} icon={faLock} />
                                                                :
                                                                <div className={'not-done-check'}></div>
                                                        }

                                                        <span className={'list-title'}>
                                                            {el.menuIcon ? (<FontAwesomeIcon className={'list-type-icon'} icon={el.menuIcon} />) : null}
                                                            <span className={'list-title-text'}> {el.title + ' ' + customDisplayOptionnalLabel(el)}</span>
                                                            <span className={'list-title-time'}>{el.titleTime ? '(' + el.titleTime + ')' : null}</span>

                                                            {
                                                                blockedModuleRequiredCondition && (
                                                                    <span className={'list-title-prerequis-text'}
                                                                        style={currentPlayContent.listIndex + 1 === el.listIndex ? { display: 'block' } : {}}>
                                                                        {t('course-play-page-menu-prerequis-text')}
                                                                        < br />
                                                                        <hr />
                                                                        {t('course-play-page-menu-prerequis-text-module-label')}: {blockedModuleRequiredConditionListIndexes}
                                                                    </span>
                                                                )
                                                            }
                                                        </span>

                                                        {
                                                            el.thisSlideDone && ['exam', 'exammultiplechoice', 'exercice', 'exercicemultiplechoices', 'dndtext', 'dndimages', 'dndmultiple', 'calculation', 'rafale', 'scorm'].includes(el.playType) && !resetPercentageResults ?
                                                                (
                                                                    <StatsPercentageBox
                                                                        exType={el.playType}
                                                                        exTag={el['exercice_tag'] ? el['exercice_tag'] : el['exam_tag'] ? el['exam_tag'] : null}
                                                                        studentId={parseInt(state.userInfos.id)}
                                                                        courseName={parsedQuery.tag}
                                                                        currentPlayContentId={el['id']}
                                                                        currentPlayIndex={currentPlayContent.listIndex}
                                                                        isScormHidden={el.playType === 'scorm' ? el.hide_percentage_score : null}
                                                                        currentPlayType={currentPlayContent.playType} />
                                                                )
                                                                : null
                                                        }


                                                        {
                                                            allCertificates?.find(certificate => certificate.moduleIdRelated === Number(el.moduleContainerId)) && (
                                                                <div
                                                                    className={'certificat-btn'}
                                                                    onClick={(e) => {
                                                                        console.log('faCertificate icon')

                                                                        const thisCertificate = allCertificates.find(certificate => certificate.moduleIdRelated === Number(el.moduleContainerId));

                                                                        generateCetificatePdf({
                                                                            variables: {
                                                                                id: thisCertificate.id,
                                                                            }
                                                                        });

                                                                        e.stopPropagation();
                                                                    }}>
                                                                    <img src={certificateIcon} alt="certificate-icon" />
                                                                </div>
                                                            )
                                                        }

                                                        <div className={'open-note-btn ' + openNoteBtnClass}
                                                            onClick={(e) => {
                                                                setCurrentNotesModalCotent({
                                                                    id: el.id,
                                                                    title: el.title,
                                                                })
                                                                setEditorClosed(false)
                                                                if (document.querySelector('.video-player')) document.querySelector('.video-player > video').pause()
                                                                e.stopPropagation();
                                                            }}>
                                                            <FontAwesomeIcon icon={faPencilAlt} />
                                                        </div>

                                                        {
                                                            el.additionalInformation && (
                                                                <div className={'additional-information-btn'}
                                                                    onClick={(e) => {
                                                                        handleShowAdditionalInformationModal(el.additionalInformation)
                                                                        e.stopPropagation();
                                                                    }}>
                                                                    <FontAwesomeIcon icon={faInfoCircle} />
                                                                </div>

                                                            )
                                                        }
                                                    </li>

                                                    {
                                                        allSondages &&
                                                        allSondages.length > 0 &&
                                                        allSondages
                                                            .filter(sondage => sondage.status === 'published' && sondage.prevModuleRelated === el.moduleContainerId)
                                                            .map((sondage, i) => (
                                                                sondageMenuListItem({
                                                                    currentRunningSondage,
                                                                    sondage,
                                                                    index: i,
                                                                    previousModuleDone: el.thisSlideDone,
                                                                    previousModuleDoneDate: el.thisSlideDoneDate
                                                                })
                                                            ))
                                                    }

                                                </>

                                            )
                                        }
                                        )
                                    }
                                </ul>

                            </div>

                            {/***************************************************/}
                            {/*COURSE START / WELCOME MODULE*/}
                            {/***************************************************/}
                            <StartSlideCnt
                                currentRunningSondage={currentRunningSondage}
                                currentPlayContent={currentPlayContent}
                                introPageSkipped={introPageSkipped}
                                menuHiddenContentClass={menuHiddenContentClass}
                                rawCoursesData={rawCoursesData}
                                handleNextSlide={handleNextSlide}
                                handleShowModal={handleShowModal}
                            />

                            {/***************************************************/}
                            {/*COURSE END MODULE*/}
                            {/***************************************************/}

                            <EndSlideCnt
                                currentRunningSondage={currentRunningSondage}
                                currentPlayContent={currentPlayContent}
                                menuHiddenContentClass={menuHiddenContentClass}
                                rawCoursesData={rawCoursesData}
                                documentsAndNotesManual={documentsAndNotesManual}
                            />

                            {/***************************************************/}
                            {/*COURSE DIVISION (BLOC) MODULE*/}
                            {/***************************************************/}

                            <DivisionSlideCnt
                                currentRunningSondage={currentRunningSondage}
                                currentPlayContent={currentPlayContent}
                                menuHiddenContentClass={menuHiddenContentClass}
                                rawCoursesData={rawCoursesData}
                                handleNextSlide={handleNextSlide}
                            />

                            {/***************************************************/}
                            {/*COURSE VIDEO MODULE*/}
                            {/***************************************************/}

                            {
                                !resetModule && (
                                    <VideoPlayerCnt
                                        currentRunningSondage={currentRunningSondage}
                                        menuHiddenContentClass={menuHiddenContentClass}
                                        currentPlayContent={currentPlayContent}
                                        videoDone={videoDone}
                                        resetModule={resetModule}
                                        replayVideoAvailable={replayVideoAvailable}
                                        updateCurrentUserProgression={updateCurrentUserProgression}
                                        handleSlideDoneFromVideo={handleSlideDoneFromVideo}
                                        handleNextSlide={handleNextSlide}
                                        setVideoDone={setVideoDone}
                                    />
                                )
                            }

                            {/***************************************************/}
                            {/*COURSE EXERCICE MODULE*/}
                            {/***************************************************/}

                            <AutoEvaluation1SlideCnt
                                currentRunningSondage={currentRunningSondage}
                                currentPlayContent={currentPlayContent}
                                isMobile={isMobile}
                                mobileNotCompatible={mobileNotCompatible}
                                resetModule={resetModule}
                                menuHiddenContentClass={menuHiddenContentClass}
                                filesSource={filesSource}
                                handleNextSlide={handleNextSlide}
                                setMenuHidden={setMenuHidden}
                                updateCurrentUserProgression={updateCurrentUserProgression}
                                setResetPercentageResults={setResetPercentageResults}
                            />

                            {/***************************************************/}
                            {/*COURSE EXERCICE MODULE*/}
                            {/***************************************************/}
                            <ExerciceSlideCnt
                                currentRunningSondage={currentRunningSondage}
                                currentPlayContent={currentPlayContent}
                                isMobile={isMobile}
                                mobileNotCompatible={mobileNotCompatible}
                                resetModule={resetModule}
                                menuHiddenContentClass={menuHiddenContentClass}
                                filesSource={filesSource}
                                handleNextSlide={handleNextSlide}
                                setMenuHidden={setMenuHidden}
                                updateCurrentUserProgression={updateCurrentUserProgression}
                                setResetPercentageResults={setResetPercentageResults}
                            />

                            {/***************************************************/}
                            {/*COURSE EXAM MODULE*/}
                            {/***************************************************/}
                            <ExamSlideCnt
                                currentRunningSondage={currentRunningSondage}
                                currentPlayContent={currentPlayContent}
                                isMobile={isMobile}
                                resetModule={resetModule}
                                mobileNotCompatible={mobileNotCompatible}
                                menuHiddenContentClass={menuHiddenContentClass}
                                filesSource={filesSource}
                                setMenuHidden={setMenuHidden}
                                updateCurrentUserProgression={updateCurrentUserProgression}
                                handleNextSlide={handleNextSlide}
                            />
                            {/***************************************************/}
                            {/*COURSE EXAM MULTIPLE CHOICE MODULE*/}
                            {/***************************************************/}
                            <ExamMultipleChoiceSlideCnt
                                currentRunningSondage={currentRunningSondage}
                                currentPlayContent={currentPlayContent}
                                isMobile={isMobile}
                                resetModule={resetModule}
                                mobileNotCompatible={mobileNotCompatible}
                                menuHiddenContentClass={menuHiddenContentClass}
                                filesSource={filesSource}
                                setMenuHidden={setMenuHidden}
                                updateCurrentUserProgression={updateCurrentUserProgression}
                                handleNextSlide={handleNextSlide}
                            />

                            {/***************************************************/}
                            {/*COURSE DRAG AND DROP TEXT MODULE*/}
                            {/***************************************************/}
                            <DndTextSlideCnt
                                currentRunningSondage={currentRunningSondage}
                                currentPlayContent={currentPlayContent}
                                isMobile={isMobile}
                                mobileNotCompatible={mobileNotCompatible}
                                menuHiddenContentClass={menuHiddenContentClass}
                                filesSource={filesSource}
                                setMenuHidden={setMenuHidden}
                                updateCurrentUserProgression={updateCurrentUserProgression}
                                handleNextSlide={handleNextSlide}
                            />

                            {/***************************************************/}
                            {/*COURSE DRAG AND DROP MULTIPLE CHOICES MODULE*/}
                            {/***************************************************/}

                            <DndMultipleSlideCnt
                                currentRunningSondage={currentRunningSondage}
                                currentPlayContent={currentPlayContent}
                                isMobile={isMobile}
                                mobileNotCompatible={mobileNotCompatible}
                                menuHiddenContentClass={menuHiddenContentClass}
                                filesSource={filesSource}
                                setMenuHidden={setMenuHidden}
                                updateCurrentUserProgression={updateCurrentUserProgression}
                                handleNextSlide={handleNextSlide}
                            />

                            {/***************************************************/}
                            {/*COURSE DRAG AND DROP WITH IMAGE MODULE*/}
                            {/***************************************************/}

                            <DndImagesSlideCnt
                                currentRunningSondage={currentRunningSondage}
                                currentPlayContent={currentPlayContent}
                                isMobile={isMobile}
                                mobileNotCompatible={mobileNotCompatible}
                                menuHiddenContentClass={menuHiddenContentClass}
                                filesSource={filesSource}
                                setMenuHidden={setMenuHidden}
                                updateCurrentUserProgression={updateCurrentUserProgression}
                                handleNextSlide={handleNextSlide}
                            />

                            {/***************************************************/}
                            {/*COURSE CALCULATION MODULE*/}
                            {/***************************************************/}

                            <CalculationSlideCnt
                                currentRunningSondage={currentRunningSondage}
                                currentPlayContent={currentPlayContent}
                                isMobile={isMobile}
                                mobileNotCompatible={mobileNotCompatible}
                                menuHiddenContentClass={menuHiddenContentClass}
                                filesSource={filesSource}
                                setMenuHidden={setMenuHidden}
                                updateCurrentUserProgression={updateCurrentUserProgression}
                                handleNextSlide={handleNextSlide}
                            />

                            {/***************************************************/}
                            {/*COURSE EN RAFALE GAME MODULE*/}
                            {/***************************************************/}

                            <RafaleSlideCnt
                                currentRunningSondage={currentRunningSondage}
                                currentPlayContent={currentPlayContent}
                                isMobile={isMobile}
                                resetModule={resetModule}
                                mobileNotCompatible={mobileNotCompatible}
                                menuHiddenContentClass={menuHiddenContentClass}
                                filesSource={filesSource}
                                setMenuHidden={setMenuHidden}
                                updateCurrentUserProgression={updateCurrentUserProgression}
                                handleNextSlide={handleNextSlide}
                            />

                            {/***************************************************/}
                            {/*COURSE EXERCICE WITH OPEN QUESTION MODULE*/}
                            {/***************************************************/}

                            <ExerciceOpenQuestionSlideCnt
                                currentRunningSondage={currentRunningSondage}
                                currentPlayContent={currentPlayContent}
                                menuLength={orderedCourseSlidesLength}
                                isMobile={isMobile}
                                resetModule={resetModule}
                                mobileNotCompatible={mobileNotCompatible}
                                menuHiddenContentClass={menuHiddenContentClass}
                                filesSource={filesSource}
                                setMenuHidden={setMenuHidden}
                                updateCurrentUserProgression={updateCurrentUserProgression}
                                handleNextSlide={handleNextSlide}
                                setResetPercentageResults={setResetPercentageResults}
                            />

                            {/***************************************************/}
                            {/*COURSE EXERCICE WITH MULTIPLE CHOICE MODULE*/}
                            {/***************************************************/}

                            <ExerciceMultipleChoicesSlideCnt
                                currentRunningSondage={currentRunningSondage}
                                currentPlayContent={currentPlayContent}
                                isMobile={isMobile}
                                resetModule={resetModule}
                                mobileNotCompatible={mobileNotCompatible}
                                menuHiddenContentClass={menuHiddenContentClass}
                                filesSource={filesSource}
                                setMenuHidden={setMenuHidden}
                                updateCurrentUserProgression={updateCurrentUserProgression}
                                handleNextSlide={handleNextSlide}
                                setResetPercentageResults={setResetPercentageResults}
                            />

                            {/***************************************************/}
                            {/*COURSE DOCUMENTS MODULE*/}
                            {/***************************************************/}

                            <DocumentSlideCnt
                                currentRunningSondage={currentRunningSondage}
                                currentPlayContent={currentPlayContent}
                                isMobile={isMobile}
                                mobileNotCompatible={mobileNotCompatible}
                                menuHiddenContentClass={menuHiddenContentClass}
                                rawCoursesData={rawCoursesData}
                                handleNextSlide={handleNextSlide}
                                updateCurrentUserProgression={updateCurrentUserProgression}
                            />

                            {/***************************************************/}
                            {/*COURSE SCORM MODULE*/}
                            {/***************************************************/}

                            {
                                !resetModule && (
                                    <ScormSlideCnt
                                        currentRunningSondage={currentRunningSondage}
                                        currentPlayContent={currentPlayContent}
                                        isMobile={isMobile}
                                        mobileNotCompatible={mobileNotCompatible}
                                        menuHiddenContentClass={menuHiddenContentClass}
                                        startSlideFromIntro={startSlideFromIntro}
                                        handleNextSlide={handleNextSlide}
                                        setVideoDone={setVideoDone}
                                        setMenuHidden={setMenuHidden}
                                        handleReturnToIntro={handleReturnToIntro}
                                        menuHidden={menuHidden}
                                        updateCurrentUserProgression={updateCurrentUserProgression}
                                        allNotesEditorContent={allNotesEditorContent}
                                        setEditorClosed={setEditorClosed}
                                    />
                                )
                            }


                            {/***************************************************/}
                            {/*COURSE HTML PAGE MODULE*/}
                            {/***************************************************/}

                            <HtmlSlideCnt
                                currentRunningSondage={currentRunningSondage}
                                currentPlayContent={currentPlayContent}
                                isMobile={isMobile}
                                mobileNotCompatible={mobileNotCompatible}
                                menuHiddenContentClass={menuHiddenContentClass}
                                rawCoursesData={rawCoursesData}
                                handleNextSlide={handleNextSlide}
                                updateCurrentUserProgression={updateCurrentUserProgression}
                                isParcoursRencontreAmbassadeurs={isParcoursRencontreAmbassadeurs}
                            />

                            {/***************************************************/}
                            {/*MEETING RESERVATION*/}
                            {/***************************************************/}

                            {
                                !resetModule && displayMeetingSection && (
                                    <MeetingReservation
                                        currentRunningSondage={currentRunningSondage}
                                        allMeetingReservations={allMeetingReservations}
                                        currentPlayContent={currentPlayContent}
                                        rawCoursesData={rawCoursesData}
                                        continuousMode={continuousMode}
                                        userCourseProgression={userCourseProgression[rawCoursesData['course_tag']]}
                                        setUserCourseRequestedMeetings={setUserCourseRequestedMeetings}
                                        userCourseRequestedMeetings={userCourseRequestedMeetings}
                                        setSelectedCourseReqMeeting={setSelectedCourseReqMeeting}
                                        selectedCourseReqMeeting={selectedCourseReqMeeting}
                                        setDisplayMeetingSection={setDisplayMeetingSection}
                                        displayMeetingSection={displayMeetingSection}
                                        menuHiddenContentClass={menuHiddenContentClass}
                                        isParcoursRencontreAmbassadeurs={isParcoursRencontreAmbassadeurs}
                                    />
                                )
                            }

                            {/***************************************************/}
                            {/*SONDAGE RESERVATION*/}
                            {/***************************************************/}

                            {
                                !resetModule && (
                                    <SondageSlideCnt
                                        currentRunningSondage={currentRunningSondage}
                                        currentRunningSondageAnswers={currentRunningSondageAnswers}
                                        currentPlayContent={currentPlayContent}
                                        rawCoursesData={rawCoursesData}
                                        menuLength={orderedCourseSlidesLength}
                                        isMobile={isMobile}
                                        resetModule={resetModule}
                                        mobileNotCompatible={mobileNotCompatible}
                                        menuHiddenContentClass={menuHiddenContentClass}
                                        filesSource={filesSource}
                                        setMenuHidden={setMenuHidden}
                                        updateCurrentUserProgression={updateCurrentUserProgression}
                                        handleNextSlideFromSondage={handleNextSlideFromSondage}
                                        setResetPercentageResults={setResetPercentageResults}
                                    />
                                )
                            }


                        </div>
                    )
            }

            {/***************************************************/}
            {/*NOTIFICATIONS DISPLAY*/}
            {/***************************************************/}

            {
                notificationStatus !== null && allNotifications && allNotifications.length > 0 ?
                    <div>
                        <div
                            className={notificationHasAlreadyOpen ? 'floatBtn' : 'floatBtnAnimation floatBtn'}
                            onClick={showModalNotification}
                            style={isNotificationModalOpen ? { pointerEvents: 'none' } : {}}
                        >
                            <FontAwesomeIcon className={notificationHasAlreadyOpen ? 'icon' : 'iconAnimation icon'} icon={faBell} />

                        </div>

                        <Modal centered show={isNotificationModalOpen} aria-labelledby="contained-modal-title-vcenter" size="lg">
                            <Modal.Header >
                                <Modal.Title> <div style={{ display: 'flex', alignItems: 'center' }}><FontAwesomeIcon style={{ marginRight: 7 }} icon={faBell} />  <div style={{ display: 'inline-flex', alignItems: 'center' }}>{allNotifications.length > 1 ? `Notifications` : `Notification `}  </div></div></Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {
                                    allNotifications.map((notification, index) => {
                                        return (
                                            <div key={index}>
                                                <div style={{ display: 'inline-flex', alignItems: 'center', marginBottom: 5 }}> <Tag style={{ height: '300%', width: '300%' }} color={notification.importance === 'Urgent' ? 'red' : 'green'}>{notification.importance}</Tag></div>
                                                <div>
                                                    <div style={{ borderRadius: '7px', padding: 7, marginBottom: 15, minHeight: 125 }} key={notification.id} className={notification.importance === 'Urgent' ? 'html-content urgent-content' : 'html-content standard-content'} dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(notification.content)) }}></div>
                                                </div>
                                            </div>
                                        )

                                    })}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="primary" onClick={handleOkModalNotification}>
                                    OK
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div> : null
            }
            {/***************************************************/}
            {/*NOTE EDITOR OVERLAY*/}
            {/***************************************************/}
            {
                introPageSkipped ?
                    (
                        <NotesEditor
                            lang={state.lang}
                            student={state.userInfos}
                            courseName={parsedQuery.tag}
                            courseTitle={currentNotesModalCotent.title}
                            setEditorClosed={setEditorClosed}
                            editorClosed={editorClosed}
                            playId={currentNotesModalCotent.id}
                            allNotesEditorContent={allNotesEditorContent}
                            setAllNotesEditorContent={setAllNotesEditorContent} />
                    ) : null
            }

            {/***************************************************/}
            {/*DOCUMENTS TO DOWNLOAD MODAL OVERLAY*/}
            {/***************************************************/}

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('course-play-page-documents-btn-label')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        rawCoursesData.documents && rawCoursesData.documents.length > 0 ?
                            (
                                rawCoursesData.documents.map((item, i) => {
                                    return (
                                        <div key={i}>
                                            <a href={state.cms2_baseURL + '/assets/' + item.directus_files_id.id} target='_blank' rel="noreferrer" >{item.directus_files_id.title}</a>
                                            <hr />
                                        </div>
                                    )
                                })
                            ) : null
                    }

                    {
                        rawCoursesData.documents_url_external && rawCoursesData.documents_url_external.length > 0 ?
                            (
                                rawCoursesData.documents_url_external.map((item, i) => {
                                    return (
                                        <div key={i}>
                                            <a href={item.url} target='_blank' rel="noreferrer" >{item.label}</a>
                                            <hr />
                                        </div>
                                    )
                                })
                            ) : null
                    }

                    {/********DOCUMENT AND NOTES MANUAL*********************************/}
                    {documentsAndNotesManual}
                    {/********DOCUMENT AND NOTES MANUAL*********************************/}

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        {t('coursePlayClose')}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={showAdditionalInformationModal}
                onHide={handleCloseAdditionalInformationModal}
                centered={true}
                size={'xl'}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('course-play-page-addition-information-title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {additionalInformationModalContent && <div dangerouslySetInnerHTML={{ __html: additionalInformationModalContent }}></div>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseAdditionalInformationModal}>
                        {t('coursePlayClose')}
                    </Button>
                </Modal.Footer>
            </Modal>


            {/***************************************************/}
            {/*CONTACT TEAMS FILTER MODAL OVERLAY*/}
            {/***************************************************/}
            {
                teamsFiltersEnabled && !isNotificationModalOpen && (
                    <Modal
                        backdrop='static'
                        show={!contactTeamSelected && showModalContactFiltersTeam} onHide={handleCloseModalContactFiltersTeam}>
                        <Modal.Header>
                            <Modal.Title>{teamsFiltersModalTexts.capitalised}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div style={{ padding: "0 0 50px 0" }}>

                                <p>
                                    {
                                        !contactTeamSelected ?
                                            (rawCoursesData.course_tag === "ADPParcoursinitialsouscripteursPrestigeautomobileethabitation" ? t('filter-message-3') + " " + teamsFiltersModalTexts.lowerCase + " " + t('filter-message-4') : t('filter-message-1') + " " + teamsFiltersModalTexts.lowerCase + " " + t('filter-message-2'))
                                            :
                                            (teamsFiltersModalTexts.capitalised + t('selected'))
                                    }
                                </p>

                                <Select
                                    showSearch
                                    allowClear
                                    filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    style={{ width: '100%' }}
                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                    listHeight={500}
                                    placeholder={t('filter-placeholder')}
                                    value={contactTeamSelected}
                                    onChange={(val) => handleFilterModulesByTeamFilters(val, backupOrderedCourseSlidesData)}>
                                    {
                                        teamsFilters.map(team => {
                                            return (
                                                <Option key={team.teamLabel}>{team.teamLabel}</Option>
                                            )
                                        })
                                    }
                                </Select>
                            </div>

                        </Modal.Body>
                    </Modal>
                )
            }


            {/***************************************************/}
            {/*CERTIFICATE DISPLAY MODAL OVERLAY*/}
            {/***************************************************/}
            <CertificateDisplay
                currentCertificateData={currentCertificateData}
                showModal={showModalCertificateDisplay}
                handleClose={() => setShowModalCertificateDisplay(false)}
            />


            {/***************************************************/}
            {/*BROKER PERMIT NUMBER INPUT MODAL OVERLAY*/}
            {/***************************************************/}
            <BrokerPermitNumberModal enabled={allCertificates && allCertificates.length > 0} />

        </div >
    )
};

export default CoursePlay;